/* eslint-disable camelcase, no-restricted-syntax */
import React from "react";
import PropTypes from "prop-types";
import { fromJS, OrderedMap } from "immutable";
import { TweenMax, TimelineMax, Back, Bounce, Linear, Power1, Elastic, Expo, Power0 } from 'gsap';
import SplitText from "gsap/SplitText";
import { connect } from "react-redux";
import { addTween, playPausePlayer, setPlayAll, setPlayHeadTime, startPlay, setAnimoFullScreen } from "../../redux/actions/appUtils";
import PlayerAudio from "./player-audio";
import { isVideoOnly, memoize } from "../timeline/timeline-helper";
import { getFrameInnerImageId, singleClipFrameToFrame } from "../frame/frame-helper";
import { transitionTime } from "../timeline/timeline-constants";
import { getSplittedDom } from "../../helper/splitTextHelper";
import { getElementAll } from "../../helper/getElement";
import { showUpgrade } from "../../redux/actions/modalAction";

class PlayerComponent extends React.Component {
  constructor(props) {
    super(props);

    // project data filter handlers
    this.filterVideos = memoize(this._filterVideos);

    /* register effect handlers here to keep if else chain minimal in addEffectsToItem */
    this.enterEffectHandlers = {
      no_Effect: this.applyNoEnterEffect,
      aiReframe: this.aireframehandler,
      rotateZoomInCw: this.rotateZoomin,
      rotateZoomInCcw: this.rotateZoomin,
      fadeIn: this.fadeInEffect,
      zoomPanEffect: this.zoomPanEffect,
      fadeinWithZoom: this.fadeinWithZoom,
      slideUp: this.enterMoveEffects,
      slideRight: this.enterMoveEffects,
      slideLeft: this.enterMoveEffects,
      slideDown: this.enterMoveEffects,
      enterPixel: this.pixelEnterHandler,
      brightSquare: this.brightSquareEnterHandler,
      bounce: this.bounceEnterHandler,
      bigToNormal: this.bigToNormal,
      enterFromLeftBottom: this.enterEffects,
      enterFromLeftTop: this.enterEffects,
      enterFromRightBottom: this.enterEffects,
      enterFromRightTop: this.enterEffects,
      enterFromTop: this.enterEffects,
      enterFromLeft: this.enterEffects,
      enterFromBottom: this.enterEffects,
      enterFromRight: this.enterEffects,
      verticalSplit: this.enterSplitEffects,
      horizontalSplit: this.enterSplitEffects,
      wipeUp: this.wipeEnterHandler,
      wipeDown: this.wipeEnterHandler,
      wipeRight: this.wipeEnterHandler,
      wipeLeft: this.wipeEnterHandler,
      rotateZoomInPopupCw: this.rotateZoominPopup,
      rotateZoomInPopupCcw: this.rotateZoominPopup,
      squareCrop: this.irishEnterHandler,
      circleCrop: this.irishEnterHandler,
      horizontalLeftSlice: this.blindsEnterHandler,
      horizontalRightSlice: this.blindsEnterHandler,
      verticalUpSlice: this.blindsEnterHandler,
      verticalDownSlice: this.blindsEnterHandler,
      squeezev: this.squeeze,
      squeezeh: this.squeeze,
      wipeBottomLeft: this.wipeEnterHandler,
      wipeBottomRight: this.wipeEnterHandler,
      wipeTopRight: this.wipeEnterHandler,
      wipeTopLeft: this.wipeEnterHandler,
      popupFromLeft: this.popupTransformHandler,
      popupFromRight: this.popupTransformHandler,
      popupFromTop: this.popupTransformHandler,
      popupFromBottom: this.popupTransformHandler,
      popupFromBottomRight: this.popupTransformHandler,
      popupFromBottomLeft: this.popupTransformHandler,
      popupFromTopLeft: this.popupTransformHandler,
      popupFromTopRight: this.popupTransformHandler,
      popupFromCenter: this.popupTransformHandler,
      bounceWords: this.bounceWordsEnterHandler,
      lettersRise: this.lettersRiseEnterHandler,
      pulseWords: this.pulseWordsEnterHandler,
      shiftWords: this.shiftWordsEnterHandler,
      stompWords: this.stompWordsEnterHandler,
      bounceLetters: this.bounceLettersEnterHandler,
      skateLetters: this.skateLettersEnterHandler,
      skateWords: this.skateWordsEnterHandler,
      lineSide: this.lineSlideEnterHandler,
      lineSideZigZag: this.lineSlideZigZagEnterHandler,
      pan: this.panInEnterHandler,
      emerge: this.emergeEnterHandler,
      slideOpen: this.slideOpenEnterHandler
    };
    /* register effect handlers here to keep if else chain minimal in addEffectsToItem */
    this.exitEffectHandlers = {
      no_Effect: this.applyNoExitEffect,
      rotateZoomOutCw: this.applyRotateZoomOutEffect,
      rotateZoomOutCcw: this.applyRotateZoomOutEffect,
      rotateZoomOutPopupCcw: this.rotateZoomoutPopup,
      rotateZoomOutPopupCw: this.rotateZoomoutPopup,
      fadeOut: this.fadeOutEffect,
      fadeoutWithZoom: this.fadeoutWithZoom,
      pixel: this.exitPixelHandler,
      brightSquare: this.brightSquareExitHandler,
      normalToBig: this.normalToBig,
      exitToLeft: this.exitEffects,
      exitToLeftBottom: this.exitEffects,
      exitToTop: this.exitEffects,
      exitToRight: this.exitEffects,
      exitToBottom: this.exitEffects,
      exitToRightTop: this.exitEffects,
      exitToRightBottom: this.exitEffects,
      exitToLeftTop: this.exitEffects,
      slideDown: this.exitHideEffects,
      slideRight: this.exitHideEffects,
      slideUp: this.exitHideEffects,
      slideLeft: this.exitHideEffects,
      wipeUp: this.wipeExitHandler,
      wipeDown: this.wipeExitHandler,
      wipeRight: this.wipeExitHandler,
      wipeLeft: this.wipeExitHandler,
      squareCrop: this.irishExitHandler,
      circleCrop: this.irishExitHandler,
      exitZoomIn: this.exitZoomIn,
      verticalUpSlice: this.blindsExitHandler,
      verticalDownSlice: this.blindsExitHandler,
      horizontalLeftSlice: this.blindsExitHandler,
      horizontalRightSlice: this.blindsExitHandler,
      wipeBottomLeft: this.wipeExitHandler,
      wipeBottomRight: this.wipeExitHandler,
      wipeTopRight: this.wipeExitHandler,
      wipeTopLeft: this.wipeExitHandler,
      popDownToLeft: this.popdownTransformHandler,
      popDownToRight: this.popdownTransformHandler,
      popDownToTop: this.popdownTransformHandler,
      popDownToBottom: this.popdownTransformHandler,
      popDownToTopLeft: this.popdownTransformHandler,
      popDownToBottomLeft: this.popdownTransformHandler,
      popDownToBottomRight: this.popdownTransformHandler,
      popDownToTopRight: this.popdownTransformHandler,
      popDownToCenter: this.popdownTransformHandler,
      bounceWords: this.bounceWordsExitHandler,
      lettersRise: this.lettersRiseExitHandler,
      pulseWords: this.pulseWordsExitHandler,
      shiftWords: this.shiftWordsExitHandler,
      stompWords: this.stompWordsExitHandler,
      bounceLetters: this.bounceLettersExitHandler,
      skateLetters: this.skateLettersExitHandler,
      skateWords: this.skateWordsExitHandler,
      lineSide: this.lineSlideExitHandler,
      lineSideZigZag: this.lineSlideZigZagExitHandler,
      pan: this.panInExitHandler,
      emerge: this.emergeExitHandler,
      slideOpen: this.slideOpenExitHandler
    };

    this.subtitleEnterEffectHandlers = {
      default: this.applyNoEnterEffect,
      textReveal: this.textReveal,
      textHighlight: this.textHighlight,
      textFlip: this.textFlip,
      textAlphaFadeIn: this.textAlphaFadeEffect,
      textAlphaFadeOut: this.textAlphaFadeEffect,
      textScaleIn: this.textScaleIn,
      textRevealWordbyWord: this.textRevealWordbyWord,
      textFloatDown: this.textFloat,
      textFloatUp: this.textFloat,
      textDropIn: this.textDropIn,
      textColorHighlight: this.textColorHighlight,
      textPopupWordbyWord: this.textPopupWordbyWord,
    };

    this.subtitleExitEffectHandlers = {
      default: this.applyNoExitEffect,
    };

    this.transitionEnterEffHandlers = {
      none_transition: this.transitionNoEnterEffect,
      exitToLeft: this.transitionSlideExitEffect,
      exitToRight: this.transitionSlideExitEffect,
      exitToTop: this.transitionSlideExitEffect,
      exitToBottom: this.transitionSlideExitEffect,
      wipeLeft: this.transitionWipeExitEffect,
      wipeUp: this.transitionWipeExitEffect,
      wipeDown: this.transitionWipeExitEffect,
      wipeRight: this.transitionWipeExitEffect,
      wipetl: this.transitionWipeExitEffect,
      wipetr: this.transitionWipeExitEffect,
      wipebl: this.transitionWipeExitEffect,
      wipebr: this.transitionWipeExitEffect,
      vuslice: this.transitionSliceExitEffect,
      vdslice: this.transitionSliceExitEffect,
      hrslice: this.transitionSliceExitEffect,
      hlslice: this.transitionSliceExitEffect,
      fade: this.transitionFade

    }
    this.transitionExitEffHandlers = {
      none_transition: this.transitionNoExitEffect,
      exitToLeft: this.transitionSlideEnterEffect,
      exitToRight: this.transitionSlideEnterEffect,
      exitToTop: this.transitionSlideEnterEffect,
      exitToBottom: this.transitionSlideEnterEffect,
      wipeLeft: this.transitionNoExitEffect,
      wipeUp: this.transitionNoExitEffect,
      wipeDown: this.transitionNoExitEffect,
      wipeRight: this.transitionNoExitEffect,
      wipetl: this.transitionNoExitEffect,
      wipetr: this.transitionNoExitEffect,
      wipebl: this.transitionNoExitEffect,
      wipebr: this.transitionNoExitEffect,
      vuslice: this.transitionNoExitEffect,
      vdslice: this.transitionNoExitEffect,
      hrslice: this.transitionNoExitEffect,
      hlslice: this.transitionNoExitEffect,
      fade: this.transitionNoExitEffect
    }
  }

  componentDidMount() {
    this.t1 = this.props.t1;
    window.t1 = this.t1
    this.addPlayerEssentials(this.props);
  }


  // eslint-disable-next-line react/sort-comp
  addMaskDOM = (domName, idVal, xVal, yVal, widthVal, heightVal, strokeWidthVal) => {
    const newDOM = document.createElementNS('http://www.w3.org/2000/svg', domName);
    newDOM.setAttributeNS(null, "id", idVal);
    newDOM.setAttributeNS(null, "x", xVal);
    newDOM.setAttributeNS(null, "y", yVal);
    newDOM.setAttributeNS(null, "width", widthVal);
    newDOM.setAttributeNS(null, "height", heightVal);
    newDOM.setAttributeNS(null, "stroke-width", strokeWidthVal);
    newDOM.setAttributeNS(null, "fill", "beige");
    newDOM.setAttributeNS(null, "stroke", "beige");
    return newDOM;
  }


  // showWhiteSpace = (targetElm) => {
  //   let nextSibling = targetElm.nextElementSibling;
  //   while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
  //     nextSibling.style.opacity = 1;
  //     nextSibling = nextSibling.nextElementSibling;
  //   }
  // }

  //  showLiTag = (targetElm) => {
  //   let prevElemSib = targetElm.previousElementSibling;
  //   while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
  //     prevElemSib.style.opacity = 1;
  //     prevElemSib = prevElemSib.previousElementSibling;
  //   }
  //   if (prevElemSib === null) {
  //     if (targetElm.parentElement.nodeName === "LI") {
  //       targetElm.parentElement.style.visibility = "visible";
  //     }
  //   }
  // }

  removeMask = (elementId) => {
    const mask_name = `mymask_${elementId}`;
    let elements = [];
    let tmpsvg; let par;
    elements = getElementAll(`*[id^="${mask_name}"]`);

    for (let cnt = 0; cnt < elements.length; cnt++) {
      tmpsvg = document.getElementById(elements[cnt].id);
      if (tmpsvg !== null) {
        par = tmpsvg.parentNode;
        par.removeChild(tmpsvg);
        document.getElementById(elementId).removeAttribute("mask");
      }
    }
  }

  currentObjectHandlder = (item) => {
    const currentObj = fromJS({
      enter: item.get("enterEffectName"),
      exit: item.get("exitEffectName"),
      enterduration: item.get("enterEnd") - item.get("enterStart"),
      exitduration: item.get("exitEnd") - item.get("exitStart"),
      xval: item.get("x"),
      yval: item.get("y"),
      width: item.get("width"),
      height: item.get("height"),
      rotation: item.get("angle"),
      parentRotation: item.get("angle"),
      // parentRotation: nextProps.get("gAngle"),
    });
    return currentObj;
  }

  addMask = (elementId, type = "", direction, rotation, scaleX = 1, scaleY = 1, effectType, suffix = "") => {
    const val = document.getElementById(elementId);
    if (!direction) {
      direction = ""
    }
    const bounds = val.getBoundingClientRect();
    if (val !== null) {
      let mask_rect = `mask_${elementId}_rect${suffix}`;
      const mask_tag = document.createElementNS('http://www.w3.org/2000/svg', "clipPath");
      let mask_name; let myRect;
      const mySVG = document.createElementNS('http://www.w3.org/2000/svg', "svg");
      let count;
      const totalCount = 10;
      switch (type) {
        case "pixelsquare":
        case "square": {
          if (effectType !== "exit") {
            mask_name = `mymask_${elementId}${type}${suffix}`;
          } else {
            mask_name = `mymask_${elementId}exitsquare${suffix}`;
            mask_rect += "exit"
          }

          val.style.clipPath = `url(#${mask_name})`;
          val.style.webkitClipPath = `url(#${mask_name})`; val.style.mozClipPath = `url(#${mask_name})`; val.style.msClipPath = `url(#${mask_name})`; val.style.oClipPath = `url(#${mask_name})`;
          mask_tag.setAttributeNS(null, "id", mask_name);
          const h = document.getElementById(elementId).offsetHeight;
          const w = document.getElementById(elementId).offsetWidth;
          let totalSquare = 6;
          if (type === "square") totalSquare = 6;
          for (count = 0; count < totalSquare; count++) {
            for (let cnt = 0; cnt < totalSquare; cnt++) {
              const changeValY = cnt * h / totalSquare;
              const changeValX = count * w / totalSquare;
              myRect = this.addMaskDOM("rect", (mask_rect + count + cnt), changeValX, changeValY, ((w / totalSquare) + 1), ((h / totalSquare) + 1), val.getAttribute("stroke-width"));
              mask_tag.appendChild(myRect);
            }
          }
          mySVG.setAttributeNS(null, "width", 0);
          mySVG.setAttributeNS(null, "height", 0);
          mySVG.appendChild(mask_tag);
          // document.getElementById(elementId).parentElement.appendChild(mySVG);
          document.getElementById(elementId).appendChild(mySVG);
          break;
        }
        case "multiWidth":
        case "multiHeight": {
          mask_name = `mymask_${elementId}${type}${suffix}`;
          const h = val.offsetHeight;
          const w = val.offsetWidth;
          val.style.clipPath = `url(#${mask_name})`;
          val.style.webkitClipPath = `url(#${mask_name})`; val.style.mozClipPath = `url(#${mask_name})`; val.style.msClipPath = `url(#${mask_name})`; val.style.oClipPath = `url(#${mask_name})`;
          mask_tag.setAttributeNS(null, "id", mask_name);
          for (count = 0; count < totalCount; count++) {
            if (type === "multiWidth") {
              myRect = this.addMaskDOM("rect", (mask_rect + count), ((count * (w / totalCount))), 0, ((w / totalCount) + 1), h, val.getAttribute("stroke-width"))
            } else if (type === "multiHeight") {
              myRect = this.addMaskDOM("rect", (mask_rect + count), 0, ((count * h / totalCount)), w, ((h / totalCount) + 1), val.getAttribute("stroke-width"))
            }
            mask_tag.appendChild(myRect);
          }
          mySVG.setAttributeNS(null, "width", 0);
          mySVG.setAttributeNS(null, "height", 0);
          mySVG.appendChild(mask_tag);
          document.getElementById(elementId).appendChild(mySVG);
          break;
        }
        case "circle": {
          mask_name = `mymask_${elementId}${type}${suffix}`;
          val.style.clipPath = `url(#${mask_name})`;
          val.style.webkitClipPath = `url(#${mask_name})`;
          val.style.mozClipPath = `url(#${mask_name})`;
          val.style.msClipPath = `url(#${mask_name})`;
          val.style.oClipPath = `url(#${mask_name})`;
          mask_tag.setAttributeNS(null, "id", mask_name);
          const myCir = document.createElementNS('http://www.w3.org/2000/svg', "circle");
          myCir.setAttributeNS(null, "id", mask_rect);
          myCir.setAttributeNS(null, "cx", (document.getElementById(elementId).offsetWidth) / 2);
          myCir.setAttributeNS(null, "cy", (document.getElementById(elementId).offsetHeight) / 2);
          myCir.setAttributeNS(null, "r", (document.getElementById(elementId).offsetWidth + document.getElementById(elementId).offsetHeight) / 2);
          myCir.setAttributeNS(null, "stroke-width", val.getAttribute("stroke-width"));
          myCir.setAttributeNS(null, "fill", "beige");
          myCir.setAttributeNS(null, "stroke", "beige");
          mask_tag.appendChild(myCir);
          mySVG.setAttributeNS(null, "width", 0);
          mySVG.setAttributeNS(null, "height", 0);
          mySVG.appendChild(mask_tag);
          document.getElementById(elementId).appendChild(mySVG);
          break;
        }
        case "splitVer":
        case "splitHor": {
          const totalCount = 2;
          mask_name = `mymask_${elementId}split`;
          val.style.clipPath = `url(#${mask_name})`;
          val.style.webkitClipPath = `url(#${mask_name})`; val.style.mozClipPath = `url(#${mask_name})`; val.style.msClipPath = `url(#${mask_name})`; val.style.oClipPath = `url(#${mask_name})`;
          mask_tag.setAttributeNS(null, "id", mask_name);
          const h = bounds.height;
          const w = bounds.width;
          for (count = 0; count < totalCount; count++) {
            if (type === "splitHor")
              myRect = this.addMaskDOM("rect", (mask_rect + count), 0, ((count * h / 2)), w, ((h / totalCount) + 1), val.getAttribute("stroke-width"))
            else
              myRect = this.addMaskDOM("rect", (mask_rect + count), ((count * w / 2)), 0, ((w / totalCount) + 1), h, val.getAttribute("stroke-width"))

            mask_tag.appendChild(myRect);
          }
          mySVG.setAttributeNS(null, "width", 0);
          mySVG.setAttributeNS(null, "height", 0);
          mySVG.appendChild(mask_tag);
          document.getElementById(elementId).appendChild(mySVG);
          break;
        }
        default: {
          const totalCount = 2;
          mask_name = `mymask_${elementId}${type}${suffix}`;
          val.style.clipPath = `url(#${mask_name})`;
          val.style.webkitClipPath = `url(#${mask_name})`;
          val.style.mozClipPath = `url(#${mask_name})`;
          val.style.msClipPath = `url(#${mask_name})`;
          val.style.oClipPath = `url(#${mask_name})`;
          mask_tag.setAttributeNS(null, "id", mask_name);
          //* Math.abs(Math.cos(rotation)) + bounds.width * Math.abs(Math.sin(rotation));
          let h = bounds.height > document.getElementById(elementId).offsetHeight ?
            bounds.height : document.getElementById(elementId).offsetHeight;
          //* Math.abs(Math.cos(rotation)) + bounds.height * Math.abs(Math.sin(rotation));
          let w = bounds.width > document.getElementById(elementId).offsetWidth ?
            bounds.width : document.getElementById(elementId).offsetWidth;
          if (type === "reveal" || type === "irish") {
            h = document.getElementById(elementId).offsetHeight;
            w = document.getElementById(elementId).offsetWidth;
          }

          if (type === "multiWipe") {
            for (count = 0; count < totalCount; count++) {
              myRect = this.addMaskDOM("rect", (mask_rect + count), 0, 0, w, h);
              mask_tag.appendChild(myRect);
            }
          } else {
            myRect = this.addMaskDOM("rect", mask_rect, 0, 0, w, h);
            mask_tag.appendChild(myRect);
          }
          type = type === "multiWipe" ? "wipe" : type;
          mySVG.setAttributeNS(null, "width", 0);
          mySVG.setAttributeNS(null, "height", 0);
          mySVG.style.top = 0;
          if (rotation) {
            if (scaleX === scaleY)
              rotation *= -1;
            const rotVal = `rotate(${rotation})`
            myRect.setAttribute("transform", rotVal);
          }
          mySVG.appendChild(mask_tag);
          document.getElementById(elementId).appendChild(mySVG);
          const element = document.getElementById(elementId);
          const maskElement = document.getElementById(mask_rect);
          if (type !== "wipe" || (type === "wipe" && rotation !== 0) && element && maskElement) {
            const newx = element.getBoundingClientRect().x - maskElement.getBoundingClientRect().x;
            const newy = element.getBoundingClientRect().y - maskElement.getBoundingClientRect().y;
            myRect.setAttribute("x", newx * scaleX);
            myRect.setAttribute("y", newy * scaleY);
          }
          break;
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.t1 !== this.props.t1) {
      this.t1 = this.props.t1;
    }

    if (prevProps.projectData !== this.props.projectData) {
      // Re-init tweens after project update (e.g. split adds new clips)

      // Clear existing tweens
      if (this.t1) {
        this.t1.clear();
      }

      // Re-add player essentials
      this.addPlayerEssentials(this.props);

      if ((this.props.isLoaded || this.props.isAnimLoaded) && !this.props.isPausePlayer && this.t1) {
        this.t1.play(this.props.runningState.get("seekPlayhead"), false);
      }
    }

    if (prevProps.isLoaded !== this.props.isLoaded && this.props.isLoaded) {
      if (this.t1) {
        this.t1.play(this.props.runningState.get("seekPlayhead"), false);
      }
    }

    //  reframeData loaded - check both projectData.reframeData and appReframeData
    // const prevAppReframeData = prevProps.appReframeData;
    // const currAppReframeData = this.props.appReframeData;
    // if (!prevAppReframeData && currAppReframeData) {

    // }
    // const prevReframeData = prevProps.projectData.get("reframeData");
    // const currReframeData = this.props.projectData.get("reframeData");
    // const prevAppReframeData = prevProps.appReframeData;
    // const currAppReframeData = this.props.appReframeData;
    // Check if reframeData just loaded from either source
    // const reframeDataJustLoaded = 
    //   (!prevReframeData && currReframeData && currReframeData.size > 0) ||
    //   (!prevAppReframeData && currAppReframeData && (currAppReframeData.size > 0 || Object.keys(currAppReframeData).length > 0));

    // if (reframeDataJustLoaded) {
    //   const workspaceItems = this.props.projectData.get("workspaceItems");
    //   workspaceItems.valueSeq().forEach((item) => {
    //     if (this.shouldCallAiReframeHandler(item)) {
    //       const itemEl = document.getElementById(item.get("id"));
    //       if (itemEl) {
    //         // eslint-disable-next-line dot-notation
    //         this.enterEffectHandlers["aiReframe"](itemEl, item);
    //       }
    //     }
    //   });
    // }

    if (
      (this.props.isAnimLoaded || this.props.isLoaded) &&
      this.props.runningState.get("seekToken") !==
      prevProps.runningState.get("seekToken")
    ) {
      const isBuffering = this.props.videoBufferStatus.size > 0;
      const seekPlayhead = this.props.runningState.get("seekPlayhead");
      if (isBuffering || (this.props.isAnimLoaded || this.props.isPausePlayer)) {
        this.t1.pause(seekPlayhead, false);
      } else {
        // Check if this is a user-initiated seek (playhead jumped significantly)
        // vs a buffer-resolved seek (small or no change from where we paused).
        // For user-initiated seeks, pause first to let videos seek to the new
        // frame. This prevents a white flash where GSAP shows a scene but the
        // video hasn't decoded the frame yet. The video's buffer mechanism will
        // emit a new seekToken when ready, which will then trigger play.
        const currentGsapTime = this.t1.time();
        const seekDelta = Math.abs(seekPlayhead - currentGsapTime);
        if (seekDelta > 0.5) {
          // Significant seek — pause at new position, let videos catch up.
          // A video's play() will register buffer status → new seekToken → resume.
          // Safety: if no buffer is registered within 200ms, resume anyway.
          this.t1.pause(seekPlayhead, false);
          clearTimeout(this._seekResumeTimer);
          this._seekResumeTimer = setTimeout(() => {
            if (this.props.videoBufferStatus.size === 0 && this.t1.paused()) {
              this.t1.play(seekPlayhead, false);
            }
          }, 200);
        } else {
          clearTimeout(this._seekResumeTimer);
          this.t1.play(seekPlayhead, false);
        }
      }
    }
    if (
      !this.props.isLoaded &&
      this.props.prefetchCompleteCount !== prevProps.prefetchCompleteCount &&
      this.props.prefetchCompleteCount === this.props.prefetchCount
    ) {
      this.props.startPlay("workspace");
    }
  }

  componentWillUnmount() {
    clearTimeout(this._seekResumeTimer);
    this.filterVideos.clear();
  }

  playEnded = () => {
    if (this.props.isAnimoPlayer || this.props.isShortsPlayer) {
      const projDuration = this.props.projectData.get("duration");
      // Pause the player and seek to the start.
      this.t1.pause(projDuration, false);
      this.props.pausePlayer({ playhead: projDuration, isPause: true });
    } else {
      this.props.setPlayAll(false, false, true);
    }
  }

  addPlayerEssentials = (props) => {
    const { projectData, isReframeMode, selectedItems, selectedSubtitles } = props;
    const projDuration = projectData.get("duration");
    const workspaceItems = projectData.get("workspaceItems");
    const workspaceBG = projectData.get("workspaceBG");
    const subtitle = projectData.get("localSubtitle");
    // to make gsap run till project duration
    this.tweenSetHandler(projDuration);

    // to stop play on project end
    this.tweenAddCallbackHandler({
      callBack: this.playEnded,
      startTime: projDuration,
      dataArr: [],
    });

    // For AI Reframe mode, also stop and jump back at the end of the reframed clip
    if (isReframeMode) {
      let parentId = null;
      if (selectedSubtitles && selectedSubtitles.size > 0) {
        const firstScene = workspaceItems.get(selectedSubtitles.first());
        parentId = firstScene?.get("dropId") || firstScene?.get("originalId");
      } else if (selectedItems && selectedItems.size > 0) {
        parentId = selectedItems.first();
      }

      if (parentId) {
        const parentItem = workspaceItems.get(parentId);
        if (parentItem) {
          const clipEnd = parentItem.get("exitEnd");
          // If the clip ends before the project, add a specific callback
          if (clipEnd && clipEnd < projDuration) {
            this.tweenAddCallbackHandler({
              callBack: () => this.playEnded(true),
              startTime: clipEnd,
              dataArr: [],
            });
          }
        }
      }
    }

    // position of groupChildren is not handled. If needed, please refer filterWorkspaceItems function of Animaker App
    workspaceItems.valueSeq().forEach((item) => {
      this.addEffectsToItem(item);
    });

    workspaceBG.valueSeq().forEach((item) => {
      this.addEffectsToBG(item);
    });
    if (subtitle) {
      subtitle.valueSeq().forEach((subtitleItem) => {
        this.addEffectsToSubtitle(subtitleItem, projectData);
      });
    }

    this.props.startPlay("player");
  }

  addEffectsToBG = (item) => {
    const itemEl = document.getElementById(item.get("id"));

    if (!itemEl) {
      // this shouldn't happen but just in case
      return;
    }

    // for now reuse effect handler of ws item until transition is implemented
    item = item.set("opacity", 1);
    item = item.set("enterStart", item.get("playStart"));
    item = item.set("exitEnd", item.get("playEnd"));
    this.enterEffectHandlers.no_Effect(itemEl, item);
    this.exitEffectHandlers.no_Effect(itemEl, item);
  }

  getReframeAnimationBoundaries = (item) => {
    const sceneData = item.get("sceneData");
    const originalId = item.get("originalId");
    if (!sceneData || !originalId) {
      return {
        parentEnterStart: item.get("enterStart"),
        parentExitEnd: item.get("exitEnd"),
        isFirst: true,
        isLast: true
      };
    }

    const workspaceItems = this.props.projectData.get("workspaceItems");
    if (!workspaceItems) {
      return {
        parentEnterStart: item.get("enterStart"),
        parentExitEnd: item.get("exitEnd"),
        isFirst: true,
        isLast: true
      };
    }

    let parentEnterStart = item.get("enterStart");
    let parentExitEnd = item.get("exitEnd");
    let isFirst = true;
    let isLast = true;

    workspaceItems.forEach((wsItem) => {
      if (wsItem.get("originalId") === originalId && wsItem.get("sceneData")) {
        const wsStart = wsItem.get("enterStart");
        const wsEnd = wsItem.get("exitEnd");
        if (wsStart < parentEnterStart) {
          parentEnterStart = wsStart;
        }
        if (wsEnd > parentExitEnd) {
          parentExitEnd = wsEnd;
        }
        if (wsStart < item.get("enterStart")) {
          isFirst = false;
        }
        if (wsEnd > item.get("exitEnd")) {
          isLast = false;
        }
      }
    });

    return { parentEnterStart, parentExitEnd, isFirst, isLast };
  }

  addEffectsToItem = (item) => {
    const itemEl = document.getElementById(item.get("id"));

    if (!itemEl) {
      // this shouldn't happen but just in case
      return;
    }

    // AI reframe parent clip should not receive animation effects.
    // Scene clips carry the visible animation timeline.
    const isAiReframeParent = item.get("isReframe") === true && !item.get("sceneData");
    if (isAiReframeParent) {
      this.tweenSetHandler(0, itemEl, { opacity: 0 });
      return;
    }
    let zoomEffect;

    let enterEffect = item.get("enterEffectName")
      ? item.get("enterEffectName")
      : "no_Effect";
    let exitEffect = item.get("exitEffectName")
      ? item.get("exitEffectName")
      : "no_Effect";

    const sceneData = item.get("sceneData");
    const originalId = item.get("originalId");
    const parentItem = sceneData && originalId
      ? this.props.projectData.getIn(["workspaceItems", originalId])
      : null;
    let parentEnterStart = item.get("enterStart");
    let parentExitEnd = item.get("exitEnd");
    let parentEnterEndForAiReframe;
    let parentExitStartForAiReframe;
    let enterEnd = item.get("enterEnd") !== undefined ? item.get("enterEnd") : parentEnterStart;
    let exitStart = item.get("exitStart") !== undefined ? item.get("exitStart") : parentExitEnd;

    let reframeBounds = null;
    if (sceneData && originalId) {
      if (parentItem) {
        const parentEnterEffect = parentItem.get("enterEffectName");
        const parentExitEffect = parentItem.get("exitEffectName");
        const parentEnterEnd = parentItem.get("enterEnd");
        const parentExitStart = parentItem.get("exitStart");

        if (parentEnterEffect && parentEnterEffect !== "no_Effect") {
          enterEffect = parentEnterEffect;
        }
        if (parentExitEffect && parentExitEffect !== "no_Effect") {
          exitEffect = parentExitEffect;
        }
        if (parentEnterEnd !== undefined) {
          enterEnd = parentEnterEnd;
          parentEnterEndForAiReframe = parentEnterEnd;
        }
        if (parentExitStart !== undefined) {
          exitStart = parentExitStart;
          parentExitStartForAiReframe = parentExitStart;
        }
      }

      const bounds = this.getReframeAnimationBoundaries(item);
      reframeBounds = bounds;
      parentEnterStart = bounds.parentEnterStart;
      parentExitEnd = bounds.parentExitEnd;
      const myStart = item.get("enterStart");
      const myEnd = item.get("exitEnd");

      enterEnd = enterEnd !== undefined ? enterEnd : parentEnterStart;
      if (enterEnd > parentExitEnd) {
        enterEnd = parentExitEnd;
      }
      exitStart = exitStart !== undefined ? exitStart : parentExitEnd;
      if (exitStart < parentEnterStart) {
        exitStart = parentEnterStart;
      }

      if (myStart >= enterEnd) {
        enterEffect = "no_Effect";
      }
      if (myEnd <= exitStart) {
        exitEffect = "no_Effect";
      }
    }

    const zoomData = item.get("zoomData");

    if (zoomData && zoomData.size > 0) {
      zoomEffect = "zoomPanEffect";
    }

    let transitionEnterEffect = item.get("transitionEnterEffect");
    let transitionExitEffect = item.get("transitionExitEffect");
    let transitionEnterId = item.get("transitionEnterId");
    let transitionExitId = item.get("transitionExitId");
    let effectItem = item;

    if (sceneData && originalId) {
      effectItem = effectItem
        .set("aiReframeParentEnterEnd", parentEnterEndForAiReframe)
        .set("aiReframeParentExitStart", parentExitStartForAiReframe)
        .set("enterEffectName", enterEffect)
        .set("exitEffectName", exitEffect);
      if (parentItem) {
        effectItem = effectItem
          .set("enterEffectIcon", parentItem.get("enterEffectIcon"))
          .set("exitEffectIcon", parentItem.get("exitEffectIcon"));
      }
    }

    if (sceneData && originalId) {
      if (parentItem) {
        const bounds = reframeBounds || this.getReframeAnimationBoundaries(item);
        if (bounds.isFirst) {
          const pEnterEff = parentItem.get("transitionEnterEffect");
          if (pEnterEff && pEnterEff !== "none_transition") {
            transitionEnterEffect = pEnterEff;
            transitionEnterId = parentItem.get("transitionEnterId");
            effectItem = effectItem.set("transitionEnterEffect", transitionEnterEffect)
              .set("transitionEnterId", transitionEnterId);
          }
        }
        if (bounds.isLast) {
          const pExitEff = parentItem.get("transitionExitEffect");
          if (pExitEff && pExitEff !== "none_transition") {
            transitionExitEffect = pExitEff;
            transitionExitId = parentItem.get("transitionExitId");
            effectItem = effectItem.set("transitionExitEffect", transitionExitEffect)
              .set("transitionExitId", transitionExitId);
          }
        }
      }
    }

    // Call aiReframe handler for all reframe scenes (not just movable ones)
    // so that opacity transitions and initial crop positioning are always set up.
    const hasAiReframe = !!sceneData;
    if (hasAiReframe) {
      // eslint-disable-next-line dot-notation
      // IMPORTANT: AI reframe handler must use scene's own enterStart/exitEnd.
      // Passing parent-level timing causes overlapping motion timelines and
      // can lead to visible double-play/freeze.
      // eslint-disable-next-line dot-notation
      this.enterEffectHandlers["aiReframe"](itemEl, effectItem);
    }

    // For AI reframe scenes, fade is handled inside aiReframe for continuity.
    // Non-fade animations still run via regular handlers on boundary scenes.
    const isAiReframeFadeEnter = hasAiReframe && enterEffect === "fadeIn";
    const allowRegularAiReframeEnter =
      hasAiReframe &&
      !isAiReframeFadeEnter &&
      enterEffect !== "no_Effect";
    if ((!hasAiReframe || allowRegularAiReframeEnter) && typeof this.enterEffectHandlers[enterEffect] === "function" && (!effectItem.get("transitionExitId") || effectItem.get("transitionExitId") === "none" || !effectItem.get("transitionExitEffect") || effectItem.get("transitionExitEffect") === "none_transition")) {
      let enterItem = sceneData && originalId ? effectItem : item;
      if (sceneData && originalId) {
        enterItem = enterItem.set("enterStart", parentEnterStart).set("enterEnd", enterEnd);
      }
      this.enterEffectHandlers[enterEffect](itemEl, enterItem);
    }
    if (typeof this.enterEffectHandlers[zoomEffect] === "function") {
      this.enterEffectHandlers[zoomEffect](itemEl, item);
    }

    const isAiReframeFadeExit = hasAiReframe && exitEffect === "fadeOut";
    const allowRegularAiReframeExit =
      hasAiReframe &&
      !isAiReframeFadeExit &&
      exitEffect !== "no_Effect";
    if ((!hasAiReframe || allowRegularAiReframeExit) && typeof this.exitEffectHandlers[exitEffect] === "function" && (!effectItem.get("transitionEnterId") || effectItem.get("transitionEnterId") === "none" || !effectItem.get("transitionEnterEffect") || effectItem.get("transitionEnterEffect") === "none_transition")) {
      let exitItem = sceneData && originalId ? effectItem : item;
      if (sceneData && originalId) {
        exitItem = exitItem.set("exitStart", exitStart).set("exitEnd", parentExitEnd);
      }
      this.exitEffectHandlers[exitEffect](itemEl, exitItem);
    }

    if (transitionEnterEffect && transitionEnterEffect !== "none_transition" && transitionEnterId && transitionEnterId !== "none" && typeof this.transitionEnterEffHandlers[transitionEnterEffect] === "function") {
      this.transitionEnterEffHandlers[transitionEnterEffect](itemEl, effectItem);
    }

    if (transitionExitEffect && transitionExitEffect !== "none_transition" && transitionExitId && transitionExitId !== "none" && typeof this.transitionExitEffHandlers[transitionExitEffect] === "function") {
      this.transitionExitEffHandlers[transitionExitEffect](itemEl, effectItem);
    }

  }

  addEffectsToSubtitle = (item, projectData) => {
    const itemEl = document.getElementById(item.getIn(["subtitleId", "timelineId"]));
    if (!itemEl) {
      // this shouldn't happen but just in case
      return;
    }
    const effectName = projectData.getIn(["subtitle", "animData", "animation"]);
    if (typeof this.subtitleEnterEffectHandlers[effectName] === "function") {
      this.subtitleEnterEffectHandlers[effectName](itemEl, item, true);
    }
    if (typeof this.subtitleExitEffectHandlers[effectName] === "function") {
      this.subtitleExitEffectHandlers[effectName](itemEl, item, true);
    }
  }

  _filterVideos = (workspaceBG, workspaceItems, workspaceChildren) => {
    let videos = OrderedMap();

    if (workspaceBG) {
      for (const [itemId, item] of workspaceBG.entrySeq()) {
        if (isVideoOnly(item.get("type"), item.get("subType"))) {
          videos = videos.set(itemId, item);
        }
      }
    }

    const setWorkspaceItemVideos = (items) => {
      for (const itemEntry of items.entrySeq()) {
        let item = itemEntry[1];
        if (item.get("isSingleClipFrame")) {
          item = singleClipFrameToFrame(item);
        }
        const itemId = itemEntry[0];

        if (isVideoOnly(item.get("type"), item.get("subType"))) {
          const isDropItem = item.get("isReframe") === true && !item.get("sceneData");
          if (!isDropItem) {
            let itemEnterStart = item.get("enterStart");
            const originalId = item.get("originalId");
            if (originalId && item.get("sceneData") && workspaceItems) {
              const parentItem = workspaceItems.get(originalId);
              if (parentItem) {
                const parentEnterStart = parentItem.get("enterStart");
                const isFirstScene = item.getIn(["sceneData", "sceneIndex"]) === 0;
                if (isFirstScene && parentEnterStart !== undefined && parentEnterStart < itemEnterStart) {
                  itemEnterStart = parentEnterStart;
                }
              }
            }

            let videoParams = item
              .set("playStart", itemEnterStart)
              .set("playEnd", item.get("exitEnd"));

            if (originalId && workspaceItems) {
              const originalItem = workspaceItems.get(originalId);
              if (originalItem) {
                const originalVolume = originalItem.get("volume");
                if (originalVolume !== undefined) {
                  // For split/multi-person layouts, only enable audio for the first person (person_1)
                  // to prevent duplicate audio from multiple scene items
                  const layout = item.getIn(["sceneData", "layout"]) || item.get("layout");
                  const personKey = item.getIn(["sceneData", "personKey"]) || item.get("personKey");
                  const isMultiPersonLayout = layout === "SPLIT" || layout === "THREE" || layout === "FOUR" || layout === "SCREENSHARE" || layout === "GAMEPLAY" || layout === "FIT" || layout === "FILL";

                  if (isMultiPersonLayout && personKey && personKey !== "person_1") {
                    // Mute audio for non-primary person items in split layouts
                    videoParams = videoParams.set("volume", 0);
                  } else {
                    videoParams = videoParams.set("volume", originalVolume);
                  }
                }
              }
            }

            // DEFENSIVE FIX (double-audio safeguard):
            // If any already-registered video from a DIFFERENT parent clip shares the
            // same assetId AND overlaps the current item's [enterStart, exitEnd] window,
            // mute this one so we never play the same underlying media twice in parallel.
            // This is a belt-and-braces safeguard for the trim-after-split aiReframe
            // bug where stale cross-video scene duplicates could otherwise produce
            // double audio and heavy playback load.
            //
            const myAssetId = videoParams.get("assetId");
            const myOriginalId = videoParams.get("originalId");
            const myStart = videoParams.get("enterStart");
            const myEnd = videoParams.get("exitEnd");
            if (myAssetId && myStart !== undefined && myEnd !== undefined) {
              const hasOverlappingSameAsset = videos.some((existingVideo) => {
                if (existingVideo.get("assetId") !== myAssetId) return false;
                // Skip items from the same parent clip — they are adjacent segments,
                // not true duplicates, even if boundaries touch or slightly overlap.
                if (myOriginalId && existingVideo.get("originalId") === myOriginalId) return false;
                if ((existingVideo.get("volume") || 0) === 0) return false;
                const exStart = existingVideo.get("enterStart");
                const exEnd = existingVideo.get("exitEnd");
                if (exStart === undefined || exEnd === undefined) return false;
                // Overlap check with tolerance: ranges intersect if start1 < end2 && start2 < end1
                const overlapTolerance = 0.01;
                return (myStart < exEnd - overlapTolerance) && (exStart < myEnd - overlapTolerance);
              });
              if (hasOverlappingSameAsset) {
                videoParams = videoParams.set("volume", 0);
              }
            }

            // SIBLING AUDIBLE CHECK (defensive double-audio safeguard for same-parent reframe family):
            // If another overlapping scene item from the SAME parent video has already been
            // registered with audio enabled, mute this one to prevent duplicate parallel audio.
            if (myOriginalId && myStart !== undefined && myEnd !== undefined && item.get("sceneData")) {
              const hasExistingAudibleSibling = videos.some((existingVideo) => {
                if (existingVideo.get("originalId") !== myOriginalId) return false;
                if ((existingVideo.get("volume") || 0) === 0) return false;
                const exStart = existingVideo.get("enterStart") ?? existingVideo.get("playStart");
                const exEnd = existingVideo.get("exitEnd") ?? existingVideo.get("playEnd");
                if (exStart === undefined || exEnd === undefined) return false;
                // Check if time ranges intersect with tolerance
                const overlapTolerance = 0.01;
                return (myStart < exEnd - overlapTolerance) && (exStart < myEnd - overlapTolerance);
              });
              if (hasExistingAudibleSibling) {
                videoParams = videoParams.set("volume", 0);
              }
            }

            // VIDEO ELEMENT DEDUPLICATION for AI reframe scenes:
            // Multiple scene items from the same AI reframe share the same underlying
            // video source (same assetId). Each video element creates its own decoder,
            // network request, and buffer — for HQ videos this overwhelms the browser.
            // Mark non-primary scene items so PlayerMedia can skip creating a <video> element.
            // The primary item (first registered per assetId within overlapping time) handles decoding.
            const isReframeSceneItem = item.get("sceneData") && item.get("originalId");
            if (isReframeSceneItem && myAssetId) {
              const layout = item.getIn(["sceneData", "layout"]) || item.get("layout");
              const isMultiPersonLayout = layout === "SPLIT" || layout === "THREE" || layout === "FOUR" || layout === "SCREENSHARE" || layout === "GAMEPLAY";

              if (!isMultiPersonLayout) {
                const hasExistingDecoder = videos.some((existingVideo) => {
                  if (existingVideo.get("assetId") !== myAssetId) return false;
                  if (!existingVideo.get("sceneData")) return false; // Do not deduplicate against parent/non-reframe items
                  if (existingVideo.get("skipVideoElement")) return false; // skip items that are themselves deduped
                  const exStart = existingVideo.get("enterStart") ?? existingVideo.get("playStart");
                  const exEnd = existingVideo.get("exitEnd") ?? existingVideo.get("playEnd");
                  if (exStart === undefined || exEnd === undefined) return false;
                  // Check if time ranges overlap — same decoder can serve both
                  const overlapTolerance = 0.01;
                  return (myStart < exEnd - overlapTolerance) && (exStart < myEnd - overlapTolerance);
                });
                if (hasExistingDecoder) {
                  videoParams = videoParams.set("skipVideoElement", true);
                }
              }
            }

            videos = videos.set(itemId, videoParams);
          }
        } else if (item.get("type") === "FRAME") {
          const clipDetails = item.get("clipDetails");
          for (const [clipId, clipDetail] of clipDetails.entrySeq()) {
            const imgDetails = clipDetail.get("imgDetails");
            if (
              isVideoOnly(imgDetails.get("type"), imgDetails.get("subType"))
            ) {
              const clipImgId = getFrameInnerImageId(itemId, clipId);
              const videoParams = imgDetails
                .set("id", clipImgId)
                .set("playStart", item.get("enterStart"))
                .set("playEnd", item.get("exitEnd"));

              videos = videos.set(clipImgId, videoParams);
            }
          }
        }
      }
    };

    if (workspaceItems) {
      setWorkspaceItemVideos(workspaceItems);
    }

    if (workspaceChildren) {
      setWorkspaceItemVideos(workspaceChildren);
    }

    return videos;
  }

  /* Put effect related code after this comment */

  rotateZoomin = (itemEl, item) => {
    const effect = item.get("enterEffectName");
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const rotationVal = item.get("angle");
    const duration = enterEnd - enterStart;
    const scaleXVal = 1;
    const scaleYVal = 1;
    this.removeMask(itemEl.id);

    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    if (effect === "rotateZoomInCw") {
      this.tweenFromToHandler(itemEl, duration, {
        scale: 0, rotation: "-=180", transformOrigin: "50% 50%",
        immediateRender: false
      }, {
        scaleX: scaleXVal, scaleY: scaleYVal,
        rotation: rotationVal, transformOrigin: "50% 50%"
      }, enterStart);
    }
    else if (effect === "rotateZoomInCcw") {
      this.tweenFromToHandler(itemEl, duration, { rotation: "+=180", scale: 0, transformOrigin: "50% 50%" }, {
        rotation: rotationVal,
        scaleX: scaleXVal, scaleY: scaleYVal, transformOrigin: "50% 50%"
      }, enterStart);
    }
  }

  rotateZoominPopup = (itemEl, item) => {
    const effect = item.get("enterEffectName");
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const rotationVal = item.get("angle");
    const duration = enterEnd - enterStart;
    const scaleXVal = 1;
    const scaleYVal = 1;
    this.removeMask(itemEl.id);
    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    this.handleTransformMatrix = (itemEl) => {
      itemEl.style.transform = itemEl.style.transform.replace(
        /matrix\(0, 0, 0, 0, (.*?), (.*?)\)/,
        "matrix(1, 0, 0, 1, $1, $2)"
      );
    };
    this.tweenFromToHandler(itemEl, duration - 0.0000001, { scale: 0, transformOrigin: "50% 50%", immediateRender: false }, { scaleX: scaleXVal, scaleY: scaleYVal, transformOrigin: "50% 50%", ease: Back.easeOut }, enterStart + 0.0000001);
    if (effect === "rotateZoomInPopupCw")
      this.tweenFromToHandler(itemEl, duration - duration / 2, { rotation: "-=180", transformOrigin: "50% 50%" }, { rotation: rotationVal, transformOrigin: "50% 50%", onComplete: () => this.handleTransformMatrix(itemEl), }, enterStart);
    else if (effect === "rotateZoomInPopupCcw") {
      this.tweenSetHandler(enterStart, itemEl, { scale: 0 });
      this.tweenFromToHandler(itemEl, duration - duration / 2, { rotation: "+=180", transformOrigin: "50% 50%" }, { rotation: rotationVal, transformOrigin: "50% 50%", onComplete: () => this.handleTransformMatrix(itemEl) }, enterStart);
    }
    // this.tweenSetHandler(enterEnd, itemEl, { opacity: item.get("opacity") });
  }

  pixelEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const enterDuration = enterEnd - enterStart;
    const suffix = "Enter";
    const mask_rect = `#mask_${itemEl.id}_rect${suffix}`;
    const maskName = `#mymask_${itemEl.id}pixelsquare${suffix}`;

    this.addMask(itemEl.id, "pixelsquare", undefined, undefined, undefined, undefined, undefined, suffix);
    this.tweenSetHandler(enterStart, itemEl, { clipPath: `url(${maskName})`, webkitClipPath: `url(${maskName})` }, true);

    const totalCount = 10;
    const shuffle = (array) => {
      let m = array.length; let t; let i;
      while (m) {
        i = Math.floor(Math.random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
      }
      return array;
    }

    let maskGroup = [];
    for (let count = 0; count < totalCount; count++) {
      for (let cnt = 0; cnt < totalCount; cnt++) {
        maskGroup.push(mask_rect + count + cnt);
      }
    }
    maskGroup = shuffle(maskGroup);

    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    this.tweenStaggerFromToHandler(maskGroup, enterDuration, { transformOrigin: "50% 50%", display: "none" }, { transformOrigin: "50% 50%", display: "block" }, enterDuration / totalCount ** 2, enterStart);
    this.tweenSetHandler(enterEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);

  }

  brightSquareEnterHandler = (itemEl, item) => {
    const enterEnd = item.get("enterEnd");
    const suffix = "Enter";
    const type = "square";
    const enterduration = item.get("enterEnd") - item.get("enterStart")
    const enterStart = item.get("enterStart");
    this.addMask(itemEl.id, type, undefined, undefined, undefined, undefined, undefined, suffix);
    const mask_rect = `#mask_${itemEl.id}_rect${suffix}`;
    const maskName = `#mymask_${itemEl.id}${type}${suffix}`;
    this.tweenSetHandler(enterStart - 0.01, itemEl, { clipPath: `url(${maskName})`, webkitClipPath: `url(${maskName})` }, true);
    const totalCount = 6;
    for (let count = 0; count < totalCount; count++) {
      for (let cnt = 0; cnt < totalCount; cnt++) {
        this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
        this.tweenFromToHandler(mask_rect + count + cnt, enterduration, { transformOrigin: "50% 50%", scale: 0 }, { transformOrigin: "50% 50%", scale: 1 }, enterStart);
      }
    }
    this.tweenSetHandler(enterEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);
  }

  bounceEnterHandler = (itemEl, item) => {
    const opacity = item.get("opacity");
    const enterStart = item.get("enterStart");
    const enterduration = item.get("enterEnd") - item.get("enterStart")
    const heightVal = item.get("height")
    const yVal = item.get("y")

    this.removeMask(itemEl.id);
    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    this.tweenFromToHandler(itemEl, enterduration,
      { y: ((heightVal) * 1) * this.props.zoomFactor },
      { opacity, y: (yVal * this.props.zoomFactor), ease: Bounce.easeOut, immediateRender: false },
      enterStart
    );
  }

  bigToNormal = (itemEl, item) => {
    const enterduration = item.get("enterEnd") - item.get("enterStart")
    const angle = item.get("angle");
    const opacity = item.get("opacity");
    const enterStart = item.get("enterStart");

    this.removeMask(itemEl.id);
    this.tweenFromToHandler(
      itemEl,
      enterduration,
      { opacity: 0, scale: 2, rotation: angle },
      { opacity, scaleX: 1, scaleY: 1, immediateRender: false },
      enterStart
    );
  }

  normalToBig = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    this.tweenToHandler(itemEl, duration / 2, { rotation: "+=360", transformOrigin: "center center" }, exitStart);
    this.tweenToHandler(itemEl, duration / 2, { scale: 5, transformOrigin: "center center", immediateRender: false, ease: Back.easeOut }, parseFloat(exitStart) + parseFloat(duration / 2));
    this.tweenToHandler(itemEl, duration / 5, { opacity: 0, transformOrigin: "center center" }, parseFloat(exitStart) + parseFloat(duration - duration / 5));
  }

  enterMoveEffects = (itemEl, item) => {
    const effect = item.get("enterEffectName");
    const xval = item.get("x");
    const yval = item.get("y");
    const rotation = item.get("angle");
    const scaleX = 1;
    const scaleY = 1;
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");

    // Detect Safari iOS
    const isSafariIOS =
      /iP(ad|hone|od)/.test(navigator.userAgent) &&
      /WebKit/.test(navigator.userAgent) &&
      !/CriOS/.test(navigator.userAgent);

    let mask_rect;

    if (isSafariIOS) {
      // Instead of SVG mask, use clip-path workaround
      itemEl.style.overflow = "hidden";
      itemEl.style.webkitClipPath = "inset(0 0 0 0)";
      itemEl.style.clipPath = "inset(0 0 0 0)";
    } else {
      this.addMask(itemEl.id, "wipe", "", rotation, scaleX, scaleY, undefined, "Enter");
      mask_rect = `#mask_${itemEl.id}_rectEnter`;
    }

    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });

    const getMaskAttr = (attr) => {
      const el = document.getElementById(`mask_${itemEl.id}_rectEnter`);
      return el ? parseFloat(el.getAttribute(attr)) : 0;
    };

    switch (effect) {
      case "slideUp": {
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { y: yval * this.props.zoomFactor + itemEl.offsetHeight },
          { y: yval * this.props.zoomFactor },
          enterStart
        );
        if (!isSafariIOS) {
          const yvalue = getMaskAttr("y");
          this.tweenfromHandler(
            mask_rect,
            enterDuration,
            { attr: { y: yvalue + itemEl.offsetHeight * -scaleY } },
            enterStart
          );
        }
        break;
      }
      case "slideRight": {
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { x: xval * this.props.zoomFactor - itemEl.offsetWidth },
          { x: xval * this.props.zoomFactor },
          enterStart
        );
        if (!isSafariIOS) {
          const xvalue = getMaskAttr("x");
          this.tweenfromHandler(
            mask_rect,
            enterDuration,
            { attr: { x: xvalue + itemEl.offsetWidth * scaleX } },
            enterStart
          );
        }
        break;
      }
      case "slideLeft": {
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { x: xval * this.props.zoomFactor + itemEl.offsetWidth },
          { x: xval * this.props.zoomFactor },
          enterStart
        );
        if (!isSafariIOS) {
          const xvalue = getMaskAttr("x");
          this.tweenfromHandler(
            mask_rect,
            enterDuration,
            { attr: { x: xvalue + itemEl.offsetWidth * -scaleX } },
            enterStart
          );
        }
        break;
      }
      case "slideDown": {
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { y: yval * this.props.zoomFactor - itemEl.offsetHeight },
          { y: yval * this.props.zoomFactor },
          enterStart
        );
        if (!isSafariIOS) {
          const yvalue = getMaskAttr("y");
          this.tweenfromHandler(
            mask_rect,
            enterDuration,
            { attr: { y: yvalue + itemEl.offsetHeight * scaleY } },
            enterStart
          );
        }
        break;
      }
      default:
        break;
    }
  };



  fadeInEffect = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const duration = enterEnd - enterStart;

    this.tweenSetHandler(0, itemEl, { opacity: 0 });
    this.tweenToHandler(itemEl, duration, { opacity: 1, immediateRender: false, ease: Back.easeNone }, enterStart);

  }

  zoomPanEffect = (itemEl, item) => {
    const rotation = item.get("angle");
    const exitEnd = item.get("exitEnd");
    const enterStart = item.get("enterStart");
    const xVal = item.get("x");
    const yVal = item.get("y");
    const zoomDatas = this.props.projectData.getIn(["localZoom"]).toJS();
    const itemHeight = this.props.projectData.get("height");
    const itemWidth = this.props.projectData.get("width");
    this.removeMask(`${itemEl.id}EnterFocus`);

    this.tweenSetHandler(0, itemEl, { opacity: 0, x: (xVal * this.props.zoomFactor), y: (yVal * this.props.zoomFactor) });

    const overlayDiv = document.getElementById(`${item.get("id")}animo`);
    this.addMask(overlayDiv.id, "wipe", "", rotation, 1, 1, "", "EnterFocus");

    TweenMax.set(overlayDiv, { transformOrigin: `0px 0px` });
    TweenMax.set(itemEl, { overflow: "visible" });

    for (const [key, data] of Object.entries(zoomDatas)) {
      const currentItemZoomData = key.split("-")[0]
      if (currentItemZoomData === item.get("id")) {
        this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
        for (const [, zoom] of Object.entries(data?.zoom)) {
          // Skip zoomOut if disabled
          if (!zoom.disableZoomOut) {
            const enterStart = zoom.start;
            const enterEnd = zoom.end;
            const duration = enterEnd - enterStart;
            // Zoom region inside the video
            const zoomW = zoom.width;
            const zoomH = zoom.height;

            const dx = zoom.x - item.get("x")
            const dy = zoom.y - item.get("y")
            const zScaleX = (itemWidth * this.props.zoomFactor) / (zoomW * this.props.zoomFactor);
            const zScaleY = (itemHeight * this.props.zoomFactor) / (zoomH * this.props.zoomFactor);
            const correctedWidth = (dx * ((itemWidth * this.props.zoomFactor) / itemWidth));
            const correctedHeight = (dy * ((itemHeight * this.props.zoomFactor) / itemHeight));
            const zX = zScaleX * correctedWidth * -1;
            const zY = zScaleY * correctedHeight * -1;
            const tweenX = zX - (xVal * this.props.zoomFactor)
            const tweenY = zY - (yVal * this.props.zoomFactor)

            this.tweenToHandler(
              overlayDiv,
              duration,
              {
                x: tweenX,
                y: tweenY,
                scaleX: zScaleX,
                scaleY: zScaleY,
                ease: "power1.inOut"
              },
              enterStart
            );
          }
        }
        this.tweenSetHandler(exitEnd, overlayDiv, { opacity: 0, scaleX: 1, scaleY: 1, x: 0, y: 0 });
      }

    }
  };

  exitZoomIn = (itemEl, item) => {
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    const id = item.get("id");
    const currentElement = document.getElementById(`${id}animo`);

    this.tweenSetHandler(exitStart, itemEl, { opacity: 1 });
    this.tweenFromToHandler(currentElement, duration, { scale: 1, transformOrigin: "50% 50%", ease: "Power1.easeIn" }, { scale: 40, transformOrigin: "50% 50%", ease: "Power1.easeIn", }, exitStart);
    this.tweenSetHandler(exitEnd, currentElement, { opacity: 0 });
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
  }

  irishEnterHandler = (itemEl, item) => {
    const effectType = item.get("enterEffectName");
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");

    this.removeMask(itemEl.id);
    if (effectType === "squareCrop")
      this.addMask(itemEl.id, "irish");
    else if (effectType === "circleCrop")
      this.addMask(itemEl.id, "circle");

    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    const mask_rect = `#mask_${itemEl.id}_rect`;
    this.tweenSetHandler(enterStart, mask_rect, { attr: { x: 0, y: 0 }, opacity: 1, transformOrigin: "50% 50%" });
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1, transformOrigin: "50% 50%" });
    this.tweenFromToHandler(mask_rect, enterDuration, { scale: 0, transformOrigin: "50% 50%" }, { scale: 1, transformOrigin: "50% 50%" }, enterStart);
  }

  irishExitHandler = (itemEl, item) => {
    const effectType = item.get("exitEffectName");
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    const suffix = "Exit";
    let type = ""
    if (effectType === "squareCrop") {
      type = "irish";
    } else if (effectType === "circleCrop") {
      type = "circle";
    }

    this.addMask(itemEl.id, type, undefined, undefined, undefined, undefined, undefined, suffix);
    const mask_rect = `#mask_${itemEl.id}_rect${suffix}`;
    const mask_name = `#mymask_${itemEl.id}${type}${suffix}`;
    this.tweenSetHandler(enterStart, mask_rect, { scale: 1, transformOrigin: "50% 50%" });
    this.tweenSetHandler(enterStart, itemEl, { scale: 1, transformOrigin: "50% 50%" });
    this.tweenToHandler(mask_rect, duration, { scale: 0, transformOrigin: "50% 50%" }, exitStart);
    this.tweenSetHandler(exitStart, itemEl, { clipPath: `url(${mask_name})`, webkitClipPath: `url(${mask_name})`, /* scale: 1, */ transformOrigin: "50% 50%"/* , opacity: 1 */ }, true);

    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
    this.tweenSetHandler(exitEnd, itemEl, { clipPath: "none", webkitClipPath: "none" }, true);

  }

  fadeinWithZoom = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const duration = enterEnd - enterStart;
    const opacity = item.get("opacity");
    const xVal = item.get("x");
    const yVal = item.get("y");

    this.removeMask(itemEl.id);
    this.tweenFromToHandler(itemEl, duration, { alpha: 0 }, { alpha: opacity, force3D: true }, enterStart);
    const popupHandler = (itemEl, startTime, enterTime, xval, yval) => {
      const groupXoffset = 0;
      const groupYoffset = 0;
      const rotateHeightOffset = 0;
      const rotateWidthOffset = 0;

      const updateWrapper = () => {
        if (!document.getElementById(`${itemEl.id}_tempWrapper`)) {
          const parent = itemEl.parentNode;
          const wrapper = document.createElement("div");
          parent.replaceChild(wrapper, itemEl);
          wrapper.appendChild(itemEl);
          itemEl.parentNode.style.width = `${itemEl.getBoundingClientRect().width}px`;
          itemEl.parentNode.style.height = `${itemEl.getBoundingClientRect().height}px`;
          itemEl.parentNode.style.display = "block";
          itemEl.parentNode.style.position = "absolute";
          itemEl.parentNode.setAttribute("id", `${itemEl.id}_tempWrapper`);
          const transformOriginVal = "50% 50%"

          this.removeMask(itemEl.id);
          this.tweenToHandler(itemEl.parentNode, startTime, { scaleX: 1, scaleY: 1, immediateRender: false, ease: Back.easeOut, }, enterTime);
          itemEl.style.left = `${-xval + rotateWidthOffset + groupXoffset}px`;
          itemEl.style.top = `${-yval + rotateHeightOffset + groupYoffset}px`;
          TweenMax.set(itemEl.parentNode, {
            x: xval - groupXoffset - rotateWidthOffset, y: yval - groupYoffset - rotateHeightOffset,
            transformOrigin: transformOriginVal, scaleX: 0, scaleY: 0
          });
        }
      }
      // Deleting the wrapper at the time effects have finished.
      function delWrapper() {
        if (document.getElementById(`${itemEl.id}_tempWrapper`))
          document.getElementById(`${itemEl.id}_tempWrapper`).replaceWith(...document.getElementById(`${itemEl.id}_tempWrapper`).childNodes)
      }
      this.t1.addCallback(delWrapper, startTime + enterTime);
      // To revert the position of the innerblock.
      function revertPosition() {
        itemEl.style.left = "0px";
        itemEl.style.top = "0px";
      }

      this.t1.addCallback(revertPosition, startTime + enterTime);
      this.t1.addCallback(updateWrapper, enterTime)
    }
    popupHandler(itemEl, duration - duration / 2, enterStart, xVal, yVal);

  }

  fadeOutEffect = (itemEl, item) => {
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart

    this.tweenSetHandler(exitStart, itemEl, { opacity: 1 });
    this.tweenToHandler(itemEl, duration, { opacity: 0, immediateRender: false, ease: Back.easeNone }, exitStart);
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
  }

  fadeoutWithZoom = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    function onStartTween(blockId) {
      this.removeMask(blockId);
      this.tweenToHandler(itemEl, duration - duration / 2, { alpha: 0, transformOrigin: "50% 50%" }, exitStart);
      this.tweenToHandler(itemEl, duration, { scale: 0, transformOrigin: "50% 50%" }, exitStart);
    }
    this.tweenfromHandler(itemEl.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
  }

  exitPixelHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    const suffix = "Exit"
    const type = 'pixelsquare'
    const maskName = `#mymask_${itemEl.id}${type}${suffix}`;

    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    this.addMask(itemEl.id, type, undefined, undefined, undefined, undefined, undefined, suffix);

    const mask_rect = `#mask_${itemEl.id}_rect${suffix}`;
    const totalCount = 20;
    this.tweenSetHandler(exitStart, itemEl, { clipPath: `url(${maskName})`, webkitClipPath: `url(${maskName})` }, true);

    let maskGroup = [];
    for (let count = 0; count < totalCount; count++) {
      for (let cnt = 0; cnt < totalCount; cnt++) {
        maskGroup.push(mask_rect + count + cnt);
      }
    }
    function shuffle(array) {
      let m = array.length; let t; let i;
      while (m) {
        i = Math.floor(Math.random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
      }
      return array;
    }
    maskGroup = shuffle(maskGroup);
    this.tweenStaggerToHandler(maskGroup, duration, { transformOrigin: "50% 50%", display: "none" }, duration / (totalCount ** 2), exitStart - duration);
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
    this.tweenSetHandler(exitEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);
  }



  enterEffects = (itemEl, item) => {
    const effect = item.get("enterEffectName");
    const xval = item.get("x");
    const yval = item.get("y");
    const enterStart = item.get("enterStart");
    const widthVal = item.get("width");
    const heightVal = item.get("height");
    const projectHeight = this.props.projectData.get("height");
    const projectWidth = this.props.projectData.get("width");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");

    this.removeMask(itemEl.id);
    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });

    switch (effect) {
      case "enterFromLeftBottom": {
        const initialXVal = widthVal * -1;
        const initialYVal = projectHeight * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          1,
          { x: initialXVal, y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      } case "enterFromLeftTop": {
        const initialXVal = widthVal * -1;
        const initialYVal = heightVal * -1;
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { x: initialXVal, y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      } case "enterFromRightBottom": {
        const initialXVal = projectWidth * this.props.zoomFactor;
        const initialYVal = projectHeight * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { x: initialXVal, y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      } case "enterFromRightTop": {
        const initialXVal = projectWidth * this.props.zoomFactor;
        const initialYVal = heightVal * -1;
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { x: initialXVal, y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      } case "enterFromTop": {
        const initialYVal = heightVal * -1;
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      } case "enterFromLeft": {
        const initialXVal = widthVal * -1;
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { x: initialXVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      } case "enterFromBottom": {
        const initialYVal = projectHeight * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      } case "enterFromRight": {
        const initialXVal = projectWidth * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          enterDuration,
          { x: initialXVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart
        );
        break;
      }
      default:
        break;
    }
  }

  transitionSlideEnterEffect = (itemEl, item) => {
    const effect = item.get("transitionExitEffect");
    const xval = item.get("x");
    const yval = item.get("y");
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd");
    const projectHeight = this.props.projectData.get("height");
    const projectWidth = this.props.projectData.get("width");
    const duration = transitionTime;

    this.tweenSetHandler(enterStart - duration, itemEl, { opacity: item.get("opacity") });

    switch (effect) {
      case "exitToLeft": {
        const initialXVal = projectWidth * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          duration,
          { x: initialXVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart - duration
        );
        break;
      }
      case "exitToRight": {
        const initialXVal = projectWidth * (-1) * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          duration,
          { x: initialXVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart - duration
        );
        break;
      }
      case "exitToTop": {
        const initialYVal = projectHeight * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          duration,
          { y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart - duration
        );
        break;
      }
      case "exitToBottom": {
        const initialYVal = projectHeight * (-1) * this.props.zoomFactor;
        this.tweenFromToHandler(
          itemEl,
          duration,
          { y: initialYVal },
          { x: xval * this.props.zoomFactor, y: yval * this.props.zoomFactor },
          enterStart - duration
        );
        break;
      }
      default:
        break;
    }
    this.tweenSetHandler(exitEnd, itemEl.id, { opacity: 0 });
  }

  transitionFade = (itemEl, item) => {

    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd");
    const duration = transitionTime;

    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    this.tweenToHandler(itemEl, duration, { opacity: 0, immediateRender: false }, exitEnd - duration);
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
  }

  transitionSlideExitEffect = (itemEl, item) => {
    const effect = item.get("transitionEnterEffect");
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitEnd");
    const projectHeight = this.props.projectData.get("height");
    const projectWidth = this.props.projectData.get("width");
    const duration = transitionTime;

    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    switch (effect) {
      case "exitToLeft": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: (projectWidth * (-1) * this.props.zoomFactor) }, exitStart - duration);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 },
          exitStart - duration);
        break;
      }
      case "exitToRight": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: projectWidth * (1) * this.props.zoomFactor }, exitStart - duration);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 },
          exitStart - duration);
        break;
      }
      case "exitToTop": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { y: (projectHeight * (-1) * this.props.zoomFactor) }, exitStart - duration);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 },
          exitStart - duration);
        break;
      }
      case "exitToBottom": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { y: (projectHeight * (1) * this.props.zoomFactor) }, exitStart - duration);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 },
          exitStart - duration);
        break;
      }
      default:
        break;
    }
    this.tweenSetHandler(exitStart, itemEl, { opacity: 0 });
  }

  transitionWipeExitEffect = (itemEl, item) => {
    const rotation = item.get("angle");


    const scaleX = 1;
    const scaleY = 1;
    const effect = item.get("transitionEnterEffect");
    const exitEnd = item.get("exitEnd");
    const duration = transitionTime;
    this.tweenSetHandler(exitEnd - 1, itemEl, { opacity: 1, transformOrigin: "50% 50%" });
    function onStartTween(blockId, type, rotation) {
      this.removeMask(blockId);
      this.addMask(blockId, "wipe", "", rotation, scaleX, scaleY, "", "Enter");
      const mask_rect = `#mask_${blockId}_rectEnter`;
      const idVal = document.getElementById(itemEl.id);
      const bboxVal = idVal.getBoundingClientRect();
      const offset = 2;
      const yval = document.getElementById(`mask_${itemEl.id}_rectEnter`).getAttribute("y")
      const xval = document.getElementById(`mask_${itemEl.id}_rectEnter`).getAttribute("x")
      const duration = transitionTime;

      TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
      TweenMax.set(itemEl, { opacity: 1, transformOrigin: "50% 50%" });

      switch (effect) {
        case "wipeLeft": {
          this.t1.to(mask_rect, duration, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } }, exitEnd - duration);
          break;
        }
        case "wipeUp": {
          this.t1.to(mask_rect, duration, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY) } }, exitEnd - duration);
          break;
        }
        case "wipeDown": {
          this.t1.to(mask_rect, duration, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } }, exitEnd - duration);
          break;
        }
        case "wipeRight": {
          this.t1.to(mask_rect, duration, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } }, exitEnd - duration);
          break;
        }
        case "wipebr": {
          this.t1.to(mask_rect, duration, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY) } }, exitEnd - duration);
          this.t1.to(mask_rect, duration, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } }, exitEnd - duration);
          break;
        }
        case "wipebl": {
          this.t1.to(mask_rect, duration, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY) } }, exitEnd - duration);
          this.t1.to(mask_rect, duration, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } }, exitEnd - duration);
          break;
        }
        case "wipetl": {
          this.t1.to(mask_rect, duration, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } }, exitEnd - duration);
          this.t1.to(mask_rect, duration, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } }, exitEnd - duration);
          break;
        }
        case "wipetr": {
          this.t1.to(mask_rect, duration, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } }, exitEnd - duration);
          this.t1.to(mask_rect, duration, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } }, exitEnd - duration);
          break;
        }
        default:
          break;
      }
      this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
    }

    this.tweenfromHandler(
      itemEl.id,
      duration,
      {
        onStart: onStartTween.bind(this),
        onStartParams: [itemEl.id, effect, rotation, 1],
        opacity: 1,
      },
      exitEnd - 1
    );
  }


  aireframehandler = (itemEl, item) => {
    // ── 1. Guard: required data must exist ──────────────────────────────────
    let sceneData = item.get("sceneData");
    if (!sceneData || !this.t1) return;
    // Some timeline update paths may store sceneData as plain JS. Normalise so
    // downstream `.get()` / `.toJS()` calls are safe.
    if (!sceneData.get && typeof sceneData === "object") {
      sceneData = fromJS(sceneData);
    }

    let scenes = this.props.projectData.getIn(["reframeData", item.get("assetId"), "scenes"]);

    if (!scenes && this.props.appReframeData) {
      const appData = this.props.appReframeData;
      // Cache the .toJS() result to avoid deep-cloning the entire reframe data
      // (potentially thousands of coordinate entries) for every scene item.
      // Invalidate when appReframeData reference changes.
      if (!this._cachedAppReframeJS || this._cachedAppReframeSource !== appData) {
        this._cachedAppReframeJS = appData.toJS ? appData.toJS() : appData;
        this._cachedAppReframeSource = appData;
      }
      const appDataJS = this._cachedAppReframeJS;

      if (appDataJS[item.get("assetId")]) {
        // Keep scenes as plain JS array — avoid expensive fromJS() conversion
        // for every scene item. We'll do a plain JS lookup below.
        scenes = appDataJS[item.get("assetId")].scenes;
      } else if (appDataJS.scenes) {
        scenes = appDataJS.scenes;
      }
    }
    const sceneId = sceneData.get ? sceneData.get("scene_id") : sceneData.scene_id;

    // Resolve the full scene data from the scenes list.
    // Support both Immutable (from projectData) and plain JS (from cached appReframeData).
    if (scenes) {
      if (scenes.find && scenes.toJS) {
        // Immutable List — use .get() for field access
        sceneData = scenes.find(s => s.get("scene_id") === sceneId) || sceneData;
      } else if (Array.isArray(scenes)) {
        // Plain JS Array — direct property access (avoids fromJS overhead)
        const found = scenes.find(s => s.scene_id === sceneId);
        if (found) {
          sceneData = found;
        }
      }
    }

    const overlayDiv = document.getElementById(`${item.get("id")}animo`);
    if (!overlayDiv) return;

    // ── 2. Normalise scene data — extract only needed fields (avoid full .toJS()
    //    which creates deep clones of large coordinate arrays and spikes GC) ──
    let scene;
    if (sceneData.toJS) {
      // Immutable Map — extract fields individually
      scene = {
        coordinates: sceneData.get("coordinates")?.toJS?.() || sceneData.get("coordinates"),
        frame_width: sceneData.get("frame_width"),
        frame_height: sceneData.get("frame_height"),
        start_time: sceneData.get("start_time"),
        end_time: sceneData.get("end_time"),
        scene_id: sceneData.get("scene_id"),
        layout: sceneData.get("layout"),
        reframe: sceneData.get("reframe"),
      };
    } else if (sceneData.get) {
      // Immutable Map without toJS (e.g. Record)
      scene = {
        coordinates: sceneData.get("coordinates")?.toJS?.() || sceneData.get("coordinates"),
        frame_width: sceneData.get("frame_width"),
        frame_height: sceneData.get("frame_height"),
        start_time: sceneData.get("start_time"),
        end_time: sceneData.get("end_time"),
        scene_id: sceneData.get("scene_id"),
        layout: sceneData.get("layout"),
        reframe: sceneData.get("reframe"),
      };
    } else {
      // Already plain JS — use directly (no conversion needed)
      scene = sceneData;
    }
    const speed = item.get("speed") || 1;
    const enterStart = item.get("enterStart");   // absolute timeline time (seconds)
    const isAiReframeScene = !!(item.get("sceneData") && item.get("originalId"));

    // ── 3. Geometry: map frame-space coords → GSAP translateX (screen px) ──
    const viewportWidth = this.props.projectData.get("width");  // 450
    const zf = this.props.zoomFactor;
    const containerWidth = item.get("width") || viewportWidth;

    // original.{x, width} are ratios relative to containerWidth (set by createNewReframe)
    const original = item.get("original");
    const origX = original ? (original.get ? original.get("x") : original.x) : 0;
    const origWidth = original ? (original.get ? original.get("width") : original.width) : 1;

    // How far the video element's left edge sits to the LEFT of the container (CSS px, pre-zf)
    const videoOffsetX = -(origX * containerWidth);

    // Actual rendered width of the landscape video inside the container (CSS px, pre-zf)
    const videoRenderedWidth = origWidth * containerWidth;

    // Convert a frame-space pixel to a rendered-video-space pixel
    const frameWidth = scene.frame_width || 1280;
    const pixelScale = videoRenderedWidth / frameWidth;

    // Hard limits: clamp translateX so the video never pans past its own edges
    const maxTweenX = videoOffsetX * zf; // rightmost pan
    const minTweenX = (containerWidth - videoRenderedWidth + videoOffsetX) * zf; // leftmost pan

    /**
     * Returns the clamped GSAP translateX value that centres the tracked
     * bounding-box (coordX, coordW) inside the portrait viewport.
     */
    const calcTweenX = (coordX, coordW = 0) => {
      const personCentre = (coordX + coordW / 2) * pixelScale;
      const raw = (containerWidth / 2 - personCentre + videoOffsetX) * zf;
      return Math.min(maxTweenX, Math.max(minTweenX, raw));
    };

    // Relative-pan clamp — must mirror getAiReframeStaticX (reframeHelper.js) exactly
    // so that the pan bounds during playback match the static/pause preview.
    // Without this, the tween values (calcTweenX - baseX) are only bounded to the
    // absolute [minTweenX, maxTweenX] window and the SPLIT bottom-box video can
    // pan past its own edges during playback even though pause preview is clamped.
    const PAN_INSET = 4 * zf; // px of guaranteed over-cover at each edge
    const canInset = (maxTweenX - minTweenX) > PAN_INSET * 2;
    const relMax = canInset ? maxTweenX - PAN_INSET : (maxTweenX + minTweenX) / 2;
    const relMin = canInset ? minTweenX + PAN_INSET : (maxTweenX + minTweenX) / 2;
    const clampRel = (rel) => Math.min(relMax, Math.max(relMin, rel));

    // ── 4. Build one sub-timeline per person track (O(n) total, O(1) GSAP overwrite cost) ──
    const allCoordinates = scene.coordinates || {};
    const itemPersonKey = item.get("personKey");
    let coordinatesToAnimate = {};
    const keys = Object.keys(allCoordinates);
    const fallbackKey = keys.length > 0 ? keys[keys.length - 1] : null;

    if (itemPersonKey && allCoordinates[itemPersonKey]) {
      coordinatesToAnimate = { [itemPersonKey]: allCoordinates[itemPersonKey] };
    } else if (fallbackKey) {
      coordinatesToAnimate = { [fallbackKey]: allCoordinates[fallbackKey] };
    }

    const SCENE_FADE_DURATION = 0.15; // seconds
    const exitEnd = item.get("exitEnd");
    const sceneItemDuration = exitEnd ? exitEnd - enterStart : 0;
    const safeFadeDur = sceneItemDuration > 0
      ? Math.min(SCENE_FADE_DURATION, sceneItemDuration / 3)
      : SCENE_FADE_DURATION;

    // For AI reframe scenes, use instant cut (no fade) to avoid jerky/bouncy effect
    // when transitioning between scenes that share the same video source.
    // The scenes are just different crop regions of the same video, so fade looks wrong.
    const isReframeScene = scene && (scene.coordinates || scene.reframe || !!item.get("originalId"));
    const useInstantCut = isReframeScene;

    // Determine if this scene is currently visible at the seek playhead.
    // If so, set its opacity directly on the DOM to avoid a flash when GSAP
    // adds the "set at time 0 → opacity: 0" tween (which renders immediately
    // because the timeline is paused at time 0 during setup).
    const seekPlayhead = this.props.runningState
      ? this.props.runningState.get("seekPlayhead") || 0
      : 0;
    const isCurrentlyVisible = seekPlayhead >= enterStart && seekPlayhead < (exitEnd || Infinity);

    // Keep the element hidden before its scene starts — but use a fromTo tween
    // with immediateRender: false instead of a "set" at time 0, so GSAP does NOT
    // flash opacity: 0 on the currently-visible scene during timeline setup.
    if (enterStart > 0) {
      if (isCurrentlyVisible) {
        // Scene is visible right now — set the DOM to visible immediately so
        // there is no flash. GSAP will take over on the next render tick.
        itemEl.style.opacity = 1;
      }
      // If there is an active enter transition, only keep the element hidden
      // until the transition starts. This prevents the opacity: 0 tween from
      // overriding the transition's opacity setting during the transition.
      const transitionExitEffect = item.get("transitionExitEffect");
      const transitionExitId = item.get("transitionExitId");
      const hasTransitionEnter = transitionExitEffect && transitionExitEffect !== "none_transition" && transitionExitId && transitionExitId !== "none";

      const hideDuration = hasTransitionEnter
        ? Math.max(0.001, enterStart - transitionTime)
        : Math.max(0.001, enterStart - 0.001);

      // Use a fromTo from time 0 → just before the transition (or enterStart) starts
      this.tweenFromToHandler(
        itemEl,
        hideDuration,
        { opacity: 0, immediateRender: false },
        { opacity: 0, immediateRender: false, ease: Linear.easeNone },
        0
      );
    }

    let enterEffect = item.get("enterEffectName")
      ? item.get("enterEffectName")
      : "no_Effect";
    let exitEffect = item.get("exitEffectName")
      ? item.get("exitEffectName")
      : "no_Effect";

    let parentEnterStart = item.get("enterStart");
    let parentExitEnd = item.get("exitEnd");
    const parentEnterEndOverride = item.get("aiReframeParentEnterEnd");
    const parentExitStartOverride = item.get("aiReframeParentExitStart");
    let enterEnd = parentEnterEndOverride !== undefined
      ? parentEnterEndOverride
      : (item.get("enterEnd") !== undefined ? item.get("enterEnd") : parentEnterStart);
    let exitStart = parentExitStartOverride !== undefined
      ? parentExitStartOverride
      : (item.get("exitStart") !== undefined ? item.get("exitStart") : parentExitEnd);

    if (sceneData && item.get("originalId")) {
      const bounds = this.getReframeAnimationBoundaries(item);
      parentEnterStart = bounds.parentEnterStart;
      parentExitEnd = bounds.parentExitEnd;
      const myStart = item.get("enterStart");
      const myEnd = item.get("exitEnd");

      enterEnd = enterEnd !== undefined ? enterEnd : parentEnterStart;
      if (enterEnd > parentExitEnd) {
        enterEnd = parentExitEnd;
      }
      exitStart = exitStart !== undefined ? exitStart : parentExitEnd;
      if (exitStart < parentEnterStart) {
        exitStart = parentEnterStart;
      }

      if (myStart >= enterEnd) {
        enterEffect = "no_Effect";
      }
      if (myEnd <= exitStart) {
        exitEffect = "no_Effect";
      }
    }

    const hasCustomEnter = enterEffect && enterEffect !== "no_Effect";
    const hasCustomExit = exitEffect && exitEffect !== "no_Effect";
    const SCENE_HIDE_EPSILON = 0.0001;

    if (!hasCustomEnter) {
      if (useInstantCut) {
        // Instant cut: show at enterStart
        this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
      } else {
        // Seamless transition: Fade in BEFORE enterStart so scene is fully visible when it "starts"
        const fadeInStart = Math.max(0, enterStart - safeFadeDur);
        this.tweenFromToHandler(
          itemEl, safeFadeDur,
          { opacity: 0, immediateRender: false },
          { opacity: 1, ease: Linear.easeNone },
          fadeInStart
        );
      }
    } else if (sceneData && item.get("originalId")) {
      if (enterEffect === "fadeIn" && enterEnd > parentEnterStart) {
        // Continuous fade-in across all AI reframe scenes:
        // each scene picks up opacity from the global parent fade window.
        const fadeWindowStart = parentEnterStart;
        const fadeWindowEnd = enterEnd;
        const sceneFadeStart = Math.max(enterStart, fadeWindowStart);
        const sceneFadeEnd = Math.min(exitEnd || enterStart, fadeWindowEnd);
        const fadeWindowDuration = fadeWindowEnd - fadeWindowStart;
        const sceneFadeDuration = sceneFadeEnd - sceneFadeStart;
        const startOpacity = Math.max(0, Math.min(1, (sceneFadeStart - fadeWindowStart) / fadeWindowDuration));
        const endOpacity = Math.max(0, Math.min(1, (sceneFadeEnd - fadeWindowStart) / fadeWindowDuration));
        if (sceneFadeDuration > 0) {
          this.tweenSetHandler(sceneFadeStart, itemEl, { opacity: startOpacity });
          this.tweenToHandler(
            itemEl,
            sceneFadeDuration,
            { opacity: endOpacity, immediateRender: false, ease: Linear.easeNone },
            sceneFadeStart
          );
        } else {
          this.tweenSetHandler(enterStart, itemEl, { opacity: endOpacity || 1 });
        }
      } else if (enterEffect === "fadeIn") {
        this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
      } else {
        // Non-fade custom enters on AI reframe should not create extra layers.
        this.tweenToHandler(
          itemEl, 0.001,
          { opacity: 1, immediateRender: false, ease: Linear.easeNone },
          enterStart
        );
      }
    }

    if (!hasCustomExit && exitEnd) {
      // Hide instantly at exitEnd - the next scene will already be at full opacity by this time
      const hideAt = isAiReframeScene ? exitEnd + SCENE_HIDE_EPSILON : exitEnd;
      this.tweenSetHandler(hideAt, itemEl, { opacity: 0 });
    } else if (isAiReframeScene && exitEnd) {
      if (exitEffect === "fadeOut" && parentExitEnd > exitStart) {
        // Continuous fade-out across all AI reframe scenes.
        const fadeWindowStart = exitStart;
        const fadeWindowEnd = parentExitEnd;
        const sceneFadeStart = Math.max(enterStart, fadeWindowStart);
        const sceneFadeEnd = Math.min(exitEnd, fadeWindowEnd);
        const fadeWindowDuration = fadeWindowEnd - fadeWindowStart;
        const sceneFadeDuration = sceneFadeEnd - sceneFadeStart;
        const startOpacity = Math.max(0, Math.min(1, 1 - ((sceneFadeStart - fadeWindowStart) / fadeWindowDuration)));
        const endOpacity = Math.max(0, Math.min(1, 1 - ((sceneFadeEnd - fadeWindowStart) / fadeWindowDuration)));

        if (sceneFadeDuration > 0) {
          this.tweenSetHandler(sceneFadeStart, itemEl, { opacity: startOpacity });
          this.tweenToHandler(
            itemEl,
            sceneFadeDuration,
            { opacity: endOpacity, immediateRender: false, ease: Linear.easeNone },
            sceneFadeStart
          );
        }
        const hideAt = exitEnd + SCENE_HIDE_EPSILON;
        this.tweenSetHandler(hideAt, itemEl, { opacity: 0 });
      } else {
        const hideAt = exitEnd + SCENE_HIDE_EPSILON;
        this.tweenSetHandler(hideAt, itemEl, { opacity: 0 });
      }
    }

    // Calculate how much of the scene's original start was skipped due to trimming
    const skippedSceneTime = (item.get("videoStart") || 0) - (scene.start_time || 0);
    const trackStartTime = enterStart - skippedSceneTime / speed;

    Object.values(coordinatesToAnimate).forEach((personCoords) => {
      if (!Array.isArray(personCoords) || personCoords.length === 0) return;

      // Sort chronologically so sub-timeline insert positions are monotonically increasing
      const sortedCoords = [...personCoords].sort((a, b) => a.t - b.t);

      // Find the first coord with non-zero duration to derive the initial pan position
      const firstCoord = sortedCoords.find((c) => c.e - c.t > 0) ?? sortedCoords[0];
      if (!firstCoord) return;

      const baseX = calcTweenX(firstCoord.x, firstCoord.w || 0);
      const prePositionTime = trackStartTime > 0 ? Math.max(0, trackStartTime - 0.001) : 0;

      // If the scene is currently visible, pre-set the overlayDiv's x position
      // to match the static aiReframeX so there's no jump when GSAP takes over.
      // The static translateX is removed when isPlayAll becomes true (React re-render),
      // so we need to apply the equivalent GSAP x before the timeline starts.
      if (isCurrentlyVisible) {
        // Calculate what x should be at the current seekPlayhead
        const sceneDuration = (scene.end_time || 0) - (scene.start_time || 0);
        const sortedForInit = [...personCoords].sort((a, b) => a.t - b.t);
        const relTime = (seekPlayhead - trackStartTime) * speed;
        let initX = 0;
        let initPrevX = 0;
        const maxCoordTInit = Math.max(...sortedForInit.map((c) => c.t));
        const coordsAreRelInit = maxCoordTInit <= sceneDuration;

        for (let ci = 0; ci < sortedForInit.length; ci++) {
          const c = sortedForInit[ci];
          const nc = sortedForInit[ci + 1];
          const endFallback = coordsAreRelInit ? sceneDuration : scene.end_time;
          const cEnd = c.e !== undefined ? c.e : (nc ? nc.t : endFallback);
          const cDur = cEnd - c.t;
          // eslint-disable-next-line no-continue
          if (cDur <= 0) continue;
          const tx = clampRel(calcTweenX(c.x, c.w || 0) - baseX);
          if (relTime >= c.t && relTime <= cEnd) {
            const prog = cDur > 0 ? (relTime - c.t) / cDur : 0;
            initX = initPrevX + (tx - initPrevX) * prog;
            break;
          }
          initPrevX = tx;
          initX = tx;
        }
        TweenMax.set(overlayDiv, { x: initX, y: 0 });
      }

      this.tweenSetHandler(prePositionTime, overlayDiv, { x: 0, y: 0 });

      // One TimelineMax per track keeps the main t1 lean (single entry vs. N tweens)
      const trackTimeline = new TimelineMax();
      let prevX = 0; // start from natural CSS position

      // Scene duration for calculating last keyframe's end time
      const sceneDuration = (scene.end_time || 0) - (scene.start_time || 0);
      const maxCoordT = Math.max(...sortedCoords.map((c) => c.t));
      const coordsAreRelative = maxCoordT <= sceneDuration;

      // ── Coordinate deduplication ──────────────────────────────────────────
      // HQ videos with dense tracking data (e.g., 30fps) can have hundreds of
      // coordinate keyframes per scene. Many consecutive keyframes produce
      // nearly identical translateX values (person barely moved). Creating a
      // GSAP tween for each one bloats the timeline and freezes the player.
      // Merge consecutive keyframes whose screen-space translateX differs by
      // less than DEDUP_THRESHOLD_PX into a single longer-duration tween.
      const DEDUP_THRESHOLD_PX = 2; // px — coordinates within this range are merged
      const dedupedCoords = [];

      for (let i = 0; i < sortedCoords.length; i++) {
        const coord = sortedCoords[i];
        const nextCoord = sortedCoords[i + 1];
        const endTimeFallback = coordsAreRelative ? sceneDuration : (scene.end_time || 0);
        const coordEnd = coord.e !== undefined
          ? coord.e
          : (nextCoord ? nextCoord.t : endTimeFallback);
        const targetX = clampRel(calcTweenX(coord.x, coord.w || 0) - baseX);

        if (dedupedCoords.length > 0) {
          const prev = dedupedCoords[dedupedCoords.length - 1];
          if (Math.abs(targetX - prev._targetX) < DEDUP_THRESHOLD_PX) {
            // Extend previous keyframe's end time to cover this one
            prev._endTime = coordEnd;
            continue; // eslint-disable-line no-continue
          }
        }

        dedupedCoords.push({
          t: coord.t,
          x: coord.x,
          w: coord.w || 0,
          _endTime: coordEnd,
          _targetX: targetX,
        });
      }


      dedupedCoords.forEach(({ t: startTime, _endTime: endTime, _targetX: targetX }) => {
        const duration = (endTime - startTime) / speed;
        if (duration <= 0) return; // skip zero-length or invalid keyframes

        const relativePosition = (coordsAreRelative ? startTime : startTime - (scene.start_time || 0)) / speed;

        // fromTo guarantees correct position on any seek (no implicit state dependency)
        // Linear.easeNone keeps velocity constant → seamless segment chaining
        trackTimeline.fromTo(
          overlayDiv,
          duration,
          { x: prevX, immediateRender: false },
          { x: targetX, ease: Linear.easeNone, overwrite: false },
          relativePosition // relative to scene start, not absolute video time
        );

        prevX = targetX;
      });


      // Attach sub-timeline at enterStart — the item's absolute position on the main GSAP timeline.
      this.t1.add(trackTimeline, trackStartTime);
    });
  }


  transitionSliceExitEffect = (itemEl, item) => {
    const exitEnd = item.get("exitEnd");
    const exitStart = item.get("exitStart");
    const duration = transitionTime;
    const effectType = item.get("transitionEnterEffect");
    const end = exitEnd;
    const totalCount = 10;
    const equalTime = duration / totalCount;

    const onStartTween = (blockId, type) => {
      this.addMask(blockId, type, undefined, undefined, undefined, undefined, undefined, "Exit");
      const mask_rect = `#mask_${itemEl.id}_rectExit`;
      const mask_name = `#mymask_${itemEl.id}${type}Exit`;
      this.tweenSetHandler(end - 1, mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
      this.tweenSetHandler(end - 1, itemEl, { opacity: 1, transformOrigin: "50% 50%" });
      this.tweenSetHandler(exitStart, itemEl, { opacity: 1, transformOrigin: "50% 50%", clipPath: `url(${mask_name})`, webkitClipPath: `url(${mask_name})` }, true);
      const duration = transitionTime;

      for (let count = 0; count < totalCount; count++) {
        switch (effectType) {
          case "vuslice": {
            const newCount = (totalCount - 1) - count;
            const startTimeVal = equalTime * count;
            const exitStart = end + startTimeVal
            this.tweenToHandler(mask_rect + newCount, equalTime, { transformOrigin: "bottom", scaleY: 0 }, exitStart - duration);
            break;
          }
          case "vdslice": {
            const startTimeVal = equalTime * count;
            const exitStart = end + startTimeVal
            this.tweenToHandler(mask_rect + count, equalTime, { transformOrigin: "top", scaleY: 0 }, exitStart - duration);
            break;
          }
          case "hrslice": {
            const startTimeVal = equalTime * count;
            const exitStart = end + startTimeVal
            this.tweenToHandler(mask_rect + count, equalTime, { scaleX: 0, transformOrigin: "0%" }, exitStart - duration);
            break;
          }
          case "hlslice": {
            const newCount = (totalCount - 1) - count;
            const startTimeVal = equalTime * count;
            const exitStart = end + startTimeVal
            this.tweenToHandler(mask_rect + newCount, equalTime, { scaleX: 0, transformOrigin: "100%" }, exitStart - duration);
            break;
          }
          default:
            break;
        }
      }
      this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
      this.tweenSetHandler(exitEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);
    }

    if (effectType === "hlslice" || effectType === "hrslice") {
      this.tweenfromHandler(itemEl.id, 0.01, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id, "multiWidth"], opacity: 1 }, end - 1);
    } else if (effectType === "vuslice" || effectType === "vdslice") {
      this.tweenfromHandler(itemEl.id, 0.01, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id, "multiHeight"], opacity: 1 }, end - 1);
    }

  }

  // Enter - NEW TEXT EFFECTS

  lineSlideZigZagEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    this.tweenSetHandler(enterStart, itemEl, { overflow: `hidden` })

    const { lines } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    const parentWidth = currentObj.get("width") /* * this.props.zoomFactor */;
    const eachLineDur = (duration / lines.length)
    let startAt = enterStart;
    function handleAllDone() {
      itemEl.style.overflow = "visible";
    }
    for (let i = 0; i < lines.length; i++) {
      const lineWords = Array.from(lines[i].querySelectorAll(".sp-wd"));
      const whiteSpaces = Array.from(lines[i].querySelectorAll('[data-ws="true"]'));
      const setX = i % 2 === 0 ? `+${parentWidth}` : `-${parentWidth}`;
      this.tweenSetHandler(enterStart, lineWords, { x: setX })
      this.tweenSetHandler((startAt + (eachLineDur / 3)), whiteSpaces, { opacity: 1 })
      this.tweenStaggerToHandler(lineWords, eachLineDur, { x: `0`, ease: Elastic.easeOut.config(1, 0.7) }, 0, startAt, handleAllDone);
      startAt += eachLineDur /* / 2 */;
    }
  }

  lineSlideEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    this.tweenSetHandler(enterStart, itemEl, { overflow: `hidden` })
    const { lines } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    const parentWidth = currentObj.get("width");
    let startAt = enterStart;
    const eachDelayDur = (duration * 0.2) / (lines.length - 1);
    let lineDuration = duration;
    let durationOffset = 0;
    function handleAllDone() {
      itemEl.style.overflow = "visible";
    }
    for (let i = 0; i < lines.length; i++) {
      const lineWords = Array.from(lines[i].querySelectorAll(".sp-wd"));
      const whiteSpaces = Array.from(lines[i].querySelectorAll('[data-ws="true"]'));
      this.tweenSetHandler(enterStart, lineWords, { x: `+${parentWidth}` });
      this.tweenSetHandler(startAt, whiteSpaces, { opacity: 1 })
      this.tweenStaggerToHandler(lineWords, lineDuration, { x: `0`, ease: Elastic.easeOut.config(1, 0.75) }, 0, startAt, handleAllDone);
      startAt += eachDelayDur;
      durationOffset += eachDelayDur;
      lineDuration = duration - durationOffset;
    }
  }

  skateWordsEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    const { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    let delaytime = enterStart
    const dur = duration
    const eachDur = dur / words.length;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
      this.tweenSetHandler(enterDuration - 0.000001, listItems, { visibility: "hidden" });
    }

    function showLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 1;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "visible";
        }
      }
    }

    function onStartHandler() {
      if (hasListItem) {
        showLiTag(this.target);
      }
    }

    function showWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 1;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function handleOnComplete() {
      showWhiteSpace(this.target);
    }

    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        this.tweenFromToHandler(words[i], eachDur, { x: "+=40", opacity: 0 }, { x: "-=40", opacity: 1, onComplete: handleOnComplete, onStart: onStartHandler }, delaytime + (eachDur / 2));
      } else {
        for (let j = 0; j < words[i].length; j++) {
          this.tweenFromToHandler(words[i][j], eachDur, { x: "+=40", opacity: 0 }, { x: "-=40", opacity: 1, onComplete: handleOnComplete, onStart: onStartHandler }, delaytime + (eachDur / 2));
        }
      }
      delaytime += eachDur;
    }
  }

  skateLettersEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { chars } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    const eachDur = duration / chars.length;
    const staggerDelay = eachDur;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
      this.tweenSetHandler(enterStart - 0.000001, listItems, { visibility: "hidden" });
    }

    function showWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 1;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function showLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 1;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "visible";
        }
      }
    }

    function handleOnComplete() {
      if (this.target.nextElementSibling === null) { /** @Note char based animation on the last element we pass the parentElement */
        showWhiteSpace(this.target.parentElement);
      }
    }

    function onStartHandler() {
      if (hasListItem) {
        if (this.target instanceof HTMLElement && this.target.previousElementSibling === null) {
          showLiTag(this.target.parentElement);
        }
      }
    }

    this.tweenSetHandler(enterStart - 0.00001, chars, { x: "+=40", opacity: 0 });
    this.tweenStaggerToHandler(chars, eachDur, { x: "-=40", opacity: 1, onComplete: handleOnComplete, onStart: onStartHandler }, staggerDelay, enterStart);
  }

  bounceLettersEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { chars } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    const eachDir = duration / chars.length;
    let startAt = enterStart;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
      this.tweenSetHandler(enterDuration - 0.000001, listItems, { visibility: "hidden" });
    }

    function showLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 1;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "visible";
        }
      }
    }

    function showWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 1;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function onStartHandler() {
      if (hasListItem) {
        if (this.target instanceof HTMLElement && this.target.previousElementSibling === null) {
          showLiTag(this.target.parentElement);
        }
      }
    }

    function handleOnComplete() {
      if (this.target.nextElementSibling === null) { /** @Note char based animation on the last element we pass the parentElement */
        showWhiteSpace(this.target.parentElement);
      }
    }

    this.tweenSetHandler(enterStart, chars, { opacity: `0` })
    for (let i = 0; i < chars.length; i++) {
      const height = chars[i].offsetHeight;
      this.tweenFromToHandler(chars[i], eachDir, { immediateRender: false, y: `-=${height}` }, { y: `+=${height}`, opacity: 1, ease: Back.easeOut.config(2), onComplete: handleOnComplete, onStart: onStartHandler }, startAt)
      startAt += eachDir;
    }
  }

  panInEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    const dummyElement = itemEl.querySelectorAll(".splEff-wrapper")[1];
    const mainElement = itemEl.querySelectorAll(".splEff-wrapper")[0];
    const collideElement = itemEl.querySelectorAll(".mask-split-collide")[0];
    const width = currentObj.get("width");

    const whiteSpaces = Array.from(itemEl.querySelectorAll('[data-ws="true"]'));
    this.tweenSetHandler(enterStart, whiteSpaces, { opacity: 1 });

    this.tweenSetHandler(0, itemEl, { overflow: "hidden" });
    this.tweenToHandler(dummyElement, 0.0000001, { overflow: "hidden", background: "rgb(198 212 188)", opacity: 1 }, enterStart);
    this.tweenFromToHandler(mainElement.firstChild, duration, { x: `-=${width}` }, { x: `+=${width}`, ease: Power0.easeNone }, enterStart);
    this.tweenFromToHandler(dummyElement, duration, { x: `+=${width}` }, { x: `-=${width}`, ease: Power0.easeNone }, enterStart);
    this.tweenFromToHandler(dummyElement.firstChild, duration, { x: `-=${width * 2}`, color: "green" }, { x: `+=${width * 2}`, ease: Power0.easeNone }, enterStart)

    this.tweenToHandler(mainElement, 0.0000001, { overflow: "hidden", background: "rgb(198 212 188)", opacity: 1 }, (enterStart + duration));
    this.tweenToHandler(mainElement.firstChild, 0.0000001, { color: "green" }, (enterStart + duration));

    if (collideElement instanceof HTMLElement) {
      this.tweenSetHandler(enterStart + duration, [mainElement, dummyElement], { visibility: "hidden" });
      this.tweenSetHandler(enterStart + duration, collideElement, { visibility: 'visible' });
    }

  }

  emergeEnterHandler = (innerblock, item) => {
    const enterstart = item.get("enterStart");
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterstart, innerblock, { opacity: 1 });
    const dummyElement = innerblock.querySelectorAll(".splEff-wrapper")[1];
    const mainElement = innerblock.querySelectorAll(".splEff-wrapper")[0];
    const collideElement = innerblock.querySelectorAll(".mask-split-collide")[0];
    let clipPathOG = "";
    let clipPathDummy = "";
    const width = currentObj.get("width");
    const height = currentObj.get("height");
    const halfHeight = (0.5 * height) * this.props.zoomFactor;
    clipPathOG = `M 0 0  L ${width} 0 L ${width} ${halfHeight} L 0 ${halfHeight} L 0 0`;
    clipPathDummy = `M 0 ${halfHeight}  L ${width} ${halfHeight} L ${width} ${height} L 0 ${height} L 0 ${halfHeight}`;

    const whiteSpaces = Array.from(innerblock.querySelectorAll('[data-ws="true"]'));
    this.tweenSetHandler(enterstart, whiteSpaces, { opacity: 1 });

    this.tweenSetHandler(0, mainElement, { clipPath: `path('${clipPathOG}')`, webkitClipPath: `path('${clipPathOG}')`, overflow: "hidden" })
    this.tweenSetHandler(0, dummyElement, { clipPath: `path('${clipPathDummy}')`, webkitClipPath: `path('${clipPathDummy}')`, overflow: "hidden", opacity: 1 })
    this.tweenSetHandler(0, mainElement.firstChild, { y: `+=${halfHeight}` })
    this.tweenSetHandler(0, dummyElement.firstChild, { y: `-=${halfHeight}` })
    this.tweenToHandler(mainElement.firstChild, duration - 0.0000001, { y: `-=${halfHeight}` }, enterstart + 0.0000001)
    this.tweenToHandler(dummyElement.firstChild, duration - 0.0000001, { y: `+=${halfHeight}` }, enterstart + 0.0000001)

    this.tweenToHandler(mainElement, 0.0000001, { clipPath: 'none', webkitClipPath: 'none', overflow: "visible" }, (enterstart + duration) - 0.0000001)
    this.tweenToHandler(dummyElement, 0.0000001, { opacity: 0 }, (enterstart + duration) - 0.0000001)

    if (collideElement instanceof HTMLElement) {
      this.tweenSetHandler(enterstart + duration, [mainElement, dummyElement], { visibility: "hidden" });
      this.tweenSetHandler(enterstart + duration, collideElement, { visibility: 'visible' });
    }

  }

  slideOpenEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const dummyElement = itemEl.querySelectorAll(".splEff-wrapper")[1];
    const mainElement = itemEl.querySelectorAll(".splEff-wrapper")[0];
    const collideElement = itemEl.querySelectorAll(".mask-split-collide")[0];
    let clipPathOG = "";
    let clipPathDummy = "";
    const width = currentObj.get("width");
    const height = currentObj.get("height");
    const topCutSt = (0.5 * width) * this.props.zoomFactor;
    const bottomCutStart = (0.5 * width) * this.props.zoomFactor;
    // Added scaled with and height to avoid mask clipping issues in zoomed view in animo render. (VMK-8934)
    const scaledWidth = width * this.props.zoomFactor;
    const scaledHeight = height * this.props.zoomFactor;
    clipPathOG = `M 0 0  L ${topCutSt} 0 L ${bottomCutStart} ${scaledHeight} L 0 ${scaledHeight} L 0 0`;
    clipPathDummy = `M ${topCutSt} 0 L ${scaledWidth} 0 L ${scaledWidth} ${scaledHeight} L ${bottomCutStart} ${scaledHeight} L ${topCutSt} 0`;

    const whiteSpaces = Array.from(itemEl.querySelectorAll('[data-ws="true"]'));
    this.tweenSetHandler(enterStart, whiteSpaces, { opacity: 1 });

    this.tweenSetHandler(0, mainElement, { clipPath: `path('${clipPathOG}')`, webkitClipPath: `path('${clipPathOG}')`, overflow: "hidden" })
    this.tweenSetHandler(0, dummyElement, { clipPath: `path('${clipPathDummy}')`, webkitClipPath: `path('${clipPathDummy}')`, overflow: "hidden", opacity: 1 })
    this.tweenSetHandler(0, mainElement.firstChild, { x: `+=${topCutSt}` })
    this.tweenSetHandler(0, dummyElement.firstChild, { x: `-=${topCutSt}` })
    this.tweenToHandler(mainElement.firstChild, duration - 0.0000001, { x: `-=${topCutSt}` }, enterStart + 0.0000001)
    this.tweenToHandler(dummyElement.firstChild, duration + 0.0000001, { x: `+=${topCutSt}` }, enterStart + 0.0000001)

    this.tweenToHandler(mainElement, 0.0000001, { clipPath: 'none', webkitClipPath: 'none', overflow: "visible" }, (enterStart + duration) - 0.0000001)
    this.tweenToHandler(dummyElement, 0.0000001, { opacity: 0 }, (enterStart + duration) - 0.0000001)

    if (collideElement instanceof HTMLElement) {
      this.tweenSetHandler(enterStart + duration, [mainElement, dummyElement], { visibility: "hidden" });
      this.tweenSetHandler(enterStart + duration, collideElement, { visibility: 'visible' });
    }
  }

  stompWordsEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });


    const parentWidth = currentObj.get("width");
    const parentHorCenter = parentWidth / 2;
    const { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    let delaytime = enterStart;
    const dur = duration;
    const eachDur = dur / words.length;

    const whiteSpaces = Array.from(itemEl.querySelectorAll('[data-ws="true"]'));
    this.tweenSetHandler(enterStart + duration, whiteSpaces, { opacity: 1 });

    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        const wordWidth = words[i].offsetWidth;
        const wordLeft = words[i].offsetLeft;
        const xTransForm = (parentHorCenter - wordLeft) - (wordWidth / 2);
        this.tweenToHandler(words[i], 0.000001, { opacity: 0 }, enterStart - 0.000001);
        this.tweenFromToHandler(words[i], eachDur - 0.000001, { scale: 4, immediateRender: false, x: xTransForm, transformOrigin: `50% 50%`, opacity: 1 }, { scale: 1, ease: Linear.easeOut }, delaytime);
        if (i !== words.length - 1) { /** ignore for last word */
          this.tweenToHandler(words[i], 0.000001, { opacity: 0 }, delaytime + eachDur);
        }
        this.tweenToHandler(words[i], 0.000001, { x: `0`, opacity: 1 }, (enterStart + duration));
      } else {
        let pseudoWidth = 0;
        const pseudoWordX = words[i][0].offsetLeft;
        for (let j = 0; j < words[i].length; j++) {
          pseudoWidth += words[i][j].offsetWidth;
        }
        const pseudoWordCenter = pseudoWordX + (pseudoWidth / 2);
        for (let j = 0; j < words[i].length; j++) {
          const xTransForm = (parentHorCenter - pseudoWordX) - (pseudoWidth / 2);
          const wordOrigin = pseudoWordCenter - (words[i][j].offsetLeft);
          this.tweenToHandler(words[i][j], 0.000001, { opacity: 0 }, enterStart - 0.000001);
          this.tweenFromToHandler(words[i][j], eachDur - 0.000001, { scale: 4, immediateRender: false, x: xTransForm, transformOrigin: `${wordOrigin}px 50%`, opacity: 1 }, { scale: 1, ease: Linear.easeOut }, delaytime);
          if (i !== words.length - 1) { /** ignore for last word */
            this.tweenToHandler(words[i][j], 0.000001, { opacity: 0 }, delaytime + eachDur);
          }
          this.tweenToHandler(words[i][j], 0.000001, { x: `0`, opacity: 1 }, (enterStart + duration - 0.000001));
        }
      }
      delaytime += eachDur;
    }
  }

  shiftWordsEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    let delaytime = enterStart;
    const eachDur = duration / words.length;
    let txtContWidthMid = currentObj.get("width") / 2;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
      this.tweenSetHandler(enterDuration - 0.000001, listItems, { visibility: "hidden" });
    }

    if (words.length) {
      if (words[0] instanceof HTMLElement) {
        txtContWidthMid -= words[0].offsetWidth / 2;
      } else {
        for (let j = 0; j < words[0].length; j++) {
          txtContWidthMid -= words[0][j].offsetWidth / 2;
        }
      }
    }
    function showWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 1;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function showLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 1;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "visible";
        }
      }
    }

    function handleOnComplete() {
      showWhiteSpace(this.target);
    }
    function onStartHandler() {
      if (hasListItem) {
        showLiTag(this.target);
      }
    }

    this.tweenToHandler(itemEl, 0.0000001, { x: `+=${txtContWidthMid}` }, enterStart);
    this.tweenToHandler(itemEl, duration, { x: `-=${txtContWidthMid}` }, enterStart + 0.00001);
    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        const itemHeight = words[i].offsetHeight;
        this.tweenFromToHandler(words[i], eachDur, { opacity: 0, y: `+=${itemHeight}` }, { opacity: 1, y: `-=${itemHeight}`, onComplete: handleOnComplete, onStart: onStartHandler }, delaytime);
      } else {
        const itemHeight = words[i][0].offsetHeight;
        for (let j = 0; j < words[i].length; j++) {
          this.tweenFromToHandler(words[i][j], eachDur, { opacity: 0, y: `+=${itemHeight}` }, { opacity: 1, y: `-=${itemHeight}`, onComplete: handleOnComplete, onStart: onStartHandler }, delaytime);
        }
      }
      delaytime += eachDur;
    }
  }

  pulseWordsEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { x: parentX } = itemEl.getBoundingClientRect();
    const { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    let delaytime = enterStart;
    const eachDur = duration / words.length;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
      this.tweenSetHandler(enterDuration - 0.000001, listItems, { visibility: "hidden" });
    }
    function showWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 1;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function showLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 1;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "visible";
        }
      }
    }

    function handleOnComplete() {
      showWhiteSpace(this.target);
    }

    function onStartHandler() {
      if (hasListItem) {
        showLiTag(this.target);
      }
    }

    for (let i = 0; i < words.length; i++) {
      this.tweenSetHandler(enterStart, words[i], { opacity: "0" });
      if (words[i] instanceof HTMLElement) {
        this.tweenFromToHandler(words[i], eachDur, { transformOrigin: "120% -70px", scale: 1.3, immediateRender: false }, { ease: Back.easeOut, scale: 1, opacity: "1", onComplete: handleOnComplete, onStart: onStartHandler }, delaytime);
      } else {
        let pseudoWidth = 0;
        const pseudoWordX = words[i][0].getBoundingClientRect().x - parentX;
        for (let j = 0; j < words[i].length; j++) {
          pseudoWidth += words[i][j].getBoundingClientRect().width;
        }
        const pseudoWordCenter = pseudoWordX + (pseudoWidth / 2);
        for (let j = 0; j < words[i].length; j++) {
          const wordOrigin = pseudoWordCenter - (words[i][j].getBoundingClientRect().x - parentX);
          this.tweenFromToHandler(words[i][j], eachDur, { transformOrigin: `${wordOrigin}px -70px`, scale: 1.3, immediateRender: false }, { ease: Back.easeOut, scale: 1, opacity: "1", onComplete: handleOnComplete, onStart: onStartHandler }, delaytime);
        }
      }
      delaytime += eachDur;
    }
  }

  lettersRiseEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("enterduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { chars } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    const staggerDur = ((duration) / chars.length) / 2;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
      this.tweenSetHandler(enterDuration - 0.000001, listItems, { visibility: "hidden" });
    }

    function showLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 1;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "visible";
        }
      }
    }

    function onStartHandler() {
      if (hasListItem) {
        if (this.target instanceof HTMLElement && this.target.previousElementSibling === null) {
          showLiTag(this.target.parentElement);
        }
      }
    }

    const whiteSpaces = Array.from(itemEl.querySelectorAll('[data-ws="true"]'));
    this.tweenSetHandler(enterStart + duration, whiteSpaces, { opacity: 1 });

    this.tweenSetHandler(enterStart, chars, { scale: 0 });
    this.tweenStaggerToHandler(chars.slice(), duration, { scale: 1, transformOrigin: "50% 100%", ease: Back.easeOut.config(1.7), onStart: onStartHandler }, staggerDur, enterStart);
  }

  bounceWordsEnterHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const currentObj = this.currentObjectHandlder(item);
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    const duration = currentObj.get("enterduration");
    const isChild = false;
    const { x: parentX } = itemEl.getBoundingClientRect();

    // Reset logic to hide all words initially
    const { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    this.tweenSetHandler(0, words, { opacity: 0, scale: 0.5 }); // Reset words to hidden state

    function showWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 1;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function showLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 1;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "visible";
        }
      }
    }

    function removeChild() {
      showWhiteSpace(this.target);
    }

    const listItems = Array.from(itemEl.querySelectorAll('li'));
    let hasListItem = false;

    if (listItems.length > 0) {
      hasListItem = true;
      this.tweenSetHandler(enterDuration - 0.000001, listItems, { visibility: "hidden" });
    }

    function onStartHandler() {
      if (hasListItem) {
        showLiTag(this.target);
      }
    }

    let delaytime = enterStart;
    const dur = duration;
    const eachDur = dur / words.length;
    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        this.tweenSetHandler(enterStart, words[i], { opacity: "0" });
        this.tweenFromToHandler(words[i], eachDur, { immediateRender: false, scale: 2, transformOrigin: "50% 50%" }, { transformOrigin: "50% 50%", opacity: 1, scale: 1, ease: Back.easeOut, onStart: onStartHandler, onComplete: removeChild }, delaytime);
      } else {
        let pseudoWidth = 0;
        const pseudoWordX = words[i][0].getBoundingClientRect().x - parentX;
        for (let j = 0; j < words[i].length; j++) {
          pseudoWidth += words[i][j].offsetWidth;
        }
        const pseudoWordCenter = pseudoWordX + (pseudoWidth / 2);
        for (let j = 0; j < words[i].length; j++) {
          this.tweenSetHandler(enterStart, words[i][j], { opacity: "0" });
          this.tweenFromToHandler(words[i][j], eachDur, { immediateRender: false, scale: 2, transformOrigin: `${pseudoWordCenter}px 50%` }, { transformOrigin: `${pseudoWordCenter}px 50%`, opacity: 1, scale: 1, ease: Back.easeOut, onStart: onStartHandler, onComplete: removeChild }, delaytime);
        }
      }
      delaytime += eachDur;
    }
  }

  popdownTransformHandler = (itemEl, item) => {
    const effect = item.get("exitEffectName");
    const exitStart = item.get("exitStart");
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    const xval = item.get("x");
    const yval = item.get("y");
    const groupXoffset = 0;
    const groupYoffset = 0;
    const rotateHeightOffset = 0;
    const rotateWidthOffset = 0;
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    let transformOriginVal = "0% 0%";

    switch (effect) {
      case "popDownToLeft":
        transformOriginVal = "0% 50%";
        break;
      case "popDownToRight":
        transformOriginVal = "100% 50%";
        break;
      case "popDownToTop":
        transformOriginVal = "50% 0%";
        break;
      case "popDownToBottom":
        transformOriginVal = "50% 100%";
        break;
      case "popDownToBottomLeft":
        transformOriginVal = "0% 100%";
        break;
      case "popDownToBottomRight":
        transformOriginVal = "100% 100%";
        break;
      case "popDownToTopLeft":
        transformOriginVal = "0% 0%";
        break;
      case "popDownToTopRight":
        transformOriginVal = "100% 0%";
        break;
      case "popDownToCenter":
        transformOriginVal = "50% 50%";
        break;
      default:
        transformOriginVal = "0% 0%";
        break;
    }

    const onStartTween = () => {
      if (!document.getElementById(`${itemEl.id}_tempWrapper`)) {
        this.removeMask(itemEl.id);
        const parent = itemEl.parentNode;
        const wrapper = document.createElement("div");
        wrapper.setAttribute("id", `${itemEl.id}_tempWrapper`);
        parent.replaceChild(wrapper, itemEl);
        wrapper.appendChild(itemEl);
        itemEl.parentNode.style.width = `${itemEl.getBoundingClientRect().width}px`;
        itemEl.parentNode.style.height = `${itemEl.getBoundingClientRect().height}px`;
        itemEl.parentNode.style.display = "block";
        itemEl.parentNode.style.position = "absolute";
        itemEl.style.left = `${-xval + groupXoffset + rotateWidthOffset}px`;
        itemEl.style.top = `${-yval + groupYoffset + rotateHeightOffset}px`;
        itemEl.parentNode.style.left = `${xval - rotateWidthOffset - groupXoffset}px`;
        itemEl.parentNode.style.top = `${yval - rotateHeightOffset - groupYoffset}px`;
        this.tweenFromToHandler(itemEl.parentNode, duration - 0.1, {
          scaleX: 1, scaleY: 1,
          transformOrigin: transformOriginVal
        }, { scaleX: 0, scaleY: 0, immediateRender: false, ease: Back.easeIn }, exitStart + 0.1);
      }
    }

    this.t1.addCallback(onStartTween, exitStart);
  }

  popupTransformHandler = (itemEl, item) => {
    const effect = item.get("enterEffectName");
    const enterStart = item.get("enterStart");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const xval = item.get("x");
    const yval = item.get("y");
    const groupXoffset = 0;
    const groupYoffset = 0;
    const rotateHeightOffset = 0;
    const rotateWidthOffset = 0;
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const updateWrapper = () => {
      if (!document.getElementById(`${itemEl.id}_tempWrapper`)) {
        const parent = itemEl.parentNode;
        const wrapper = document.createElement("div");
        parent.replaceChild(wrapper, itemEl);
        wrapper.appendChild(itemEl);
        itemEl.parentNode.style.width = `${itemEl.getBoundingClientRect().width}px`;
        itemEl.parentNode.style.height = `${itemEl.getBoundingClientRect().height}px`;
        itemEl.parentNode.style.display = "block";
        itemEl.parentNode.style.position = "absolute";
        itemEl.parentNode.setAttribute("id", `${itemEl.id}_tempWrapper`);
        let transformOriginVal = "0% 0%"; // Default value
        switch (effect) {
          case "popupFromLeft":
            transformOriginVal = "0% 50%";
            break;
          case "popupFromRight":
            transformOriginVal = "100% 50%";
            break;
          case "popupFromTop":
            transformOriginVal = "50% 0%";
            break;
          case "popupFromBottom":
            transformOriginVal = "50% 100%";
            break;
          case "popupFromBottomLeft":
            transformOriginVal = "0% 100%";
            break;
          case "popupFromBottomRight":
            transformOriginVal = "100% 100%";
            break;
          case "popupFromTopLeft":
            transformOriginVal = "0% 0%";
            break;
          case "popupFromTopRight":
            transformOriginVal = "100% 0%";
            break;
          case "popupFromCenter":
            transformOriginVal = "50% 50%";
            break;
          default:
            transformOriginVal = "0% 0%";
            break;
        }

        this.removeMask(itemEl.id);
        this.t1.to(itemEl.parentNode, enterDuration, { scaleX: 1, scaleY: 1, immediateRender: false, ease: Back.easeOut, }, enterStart);
        itemEl.style.left = `${-xval + rotateWidthOffset + groupXoffset}px`;
        itemEl.style.top = `${-yval + rotateHeightOffset + groupYoffset}px`;
        TweenMax.set(itemEl.parentNode, {
          x: xval - groupXoffset - rotateWidthOffset,
          y: yval - groupYoffset - rotateHeightOffset, transformOrigin: transformOriginVal, scaleX: 0, scaleY: 0
        });
      }
    }

    function delWrapper() {
      if (document.getElementById(`${itemEl.id}_tempWrapper`))
        document.getElementById(`${itemEl.id}_tempWrapper`).replaceWith(...document.getElementById(`${itemEl.id}_tempWrapper`).childNodes)
    }

    this.t1.addCallback(delWrapper, enterDuration + enterStart);

    function revertPosition() {
      itemEl.style.left = "0px";
      itemEl.style.top = "0px";
    }

    this.t1.addCallback(revertPosition, enterDuration + enterStart);
    this.t1.addCallback(updateWrapper, enterStart - 0.1)
  }


  // Exit - NEW TEXT EFFECTS

  bounceWordsExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { x: parentX } = itemEl.getBoundingClientRect();
    function hideWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 0;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function removeChild() {
      hideWhiteSpace(this.target);
    }
    let { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    words = words.reverse();

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
    }

    let delaytime = exitStart;
    const dur = duration;
    const eachDur = dur / words.length;
    function hideLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 0;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "hidden";
        }
      }
    }

    function onCompleteHandler() {
      if (hasListItem) {
        hideLiTag(this.target);
      }
    }

    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        this.tweenFromToHandler(words[i], eachDur, { opacity: 1, immediateRender: false, scale: 1, transformOrigin: "50% 50%" }, { opacity: 0, scale: 0, ease: Back.easeIn, onStart: removeChild, onComplete: onCompleteHandler }, delaytime);
      } else {
        let pseudoWidth = 0;
        const pseudoWordX = words[i][0].getBoundingClientRect().x - parentX;
        for (let j = 0; j < words[i].length; j++) {
          pseudoWidth += words[i][j].getBoundingClientRect().width;
        }
        const pseudoWordCenter = pseudoWordX + (pseudoWidth / 2);
        for (let j = 0; j < words[i].length; j++) {
          const wordOrigin = pseudoWordCenter - (words[i][j].getBoundingClientRect().x - parentX);
          this.tweenFromToHandler(words[i][j], eachDur, { immediateRender: false, opacity: 1, scale: 1, transformOrigin: `${wordOrigin}px 50%` }, { opacity: 0, scale: 0, ease: Back.easeIn, onStart: removeChild, onComplete: onCompleteHandler }, delaytime);
        }
      }
      delaytime += eachDur;
    }
  }

  lettersRiseExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    let { chars } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    chars = chars.reverse();

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
    }

    const whiteSpaces = Array.from(itemEl.querySelectorAll('[data-ws="true"]'));
    this.tweenSetHandler(exitStart + duration / 2, whiteSpaces, { opacity: 0 });

    const eachCharDur = (duration / chars.length);
    let startAt = exitStart;

    function hideLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 0;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "hidden";
        }
      }
    }

    function onCompleteHandler() {
      if (hasListItem) {
        if (this.target instanceof HTMLElement && this.target.previousElementSibling === null) {
          hideLiTag(this.target.parentElement);
        }
      }
    }

    for (let i = 0; i < chars.length; i++) {
      this.tweenToHandler(chars[i], duration / 2, { scale: 0, transformOrigin: "50% 100%", ease: Back.easeIn.config(1.7), onComplete: onCompleteHandler }, startAt);
      startAt += (eachCharDur / 2);
    }
  }

  pulseWordsExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { x: parentX } = itemEl.getBoundingClientRect();
    let { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    words = words.reverse()

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
    }

    let delaytime = exitStart;
    const eachDur = duration / words.length;

    function hideLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 0;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "hidden";
        }
      }
    }

    function hideWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 0;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function handleOnStart() {
      hideWhiteSpace(this.target);
    }
    function handleOnComplete() {
      if (hasListItem) {
        hideLiTag(this.target);
      }
    }

    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        this.tweenFromToHandler(words[i], eachDur, { immediateRender: false, transformOrigin: "120% -70px", scale: 1 }, { ease: Back.easeIn, scale: 1.3, opacity: "0", onStart: handleOnStart, onComplete: handleOnComplete }, delaytime);
      } else {
        let pseudoWidth = 0;
        const pseudoWordX = words[i][0].getBoundingClientRect().x - parentX;
        for (let j = 0; j < words[i].length; j++) {
          pseudoWidth += words[i][j].getBoundingClientRect().width;
        }
        const pseudoWordCenter = pseudoWordX + (pseudoWidth / 2);
        for (let j = 0; j < words[i].length; j++) {
          const wordOrigin = pseudoWordCenter - (words[i][j].getBoundingClientRect().x - parentX);
          this.tweenFromToHandler(words[i][j], eachDur, { immediateRender: false, transformOrigin: `${wordOrigin}px -70px`, scale: 1 }, { ease: Back.easeIn, scale: 1.3, opacity: "0", onStart: handleOnStart, onComplete: handleOnComplete }, delaytime);
        }
      }
      delaytime += eachDur;
    }
  }

  shiftWordsExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    let { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    let delaytime = exitStart;
    const eachDur = duration / words.length;
    let txtContWidthMid = currentObj.get("width") / 2;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
    }

    if (words.length) {
      if (words[0] instanceof HTMLElement) {
        txtContWidthMid -= words[0].offsetWidth / 2;
      } else {
        for (let j = 0; j < words[0].length; j++) {
          txtContWidthMid -= words[0][j].offsetWidth / 2;
        }
      }
    }

    words = words.reverse();

    function hideLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 0;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "hidden";
        }
      }
    }

    function hideWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 0;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function handleOnStart() {
      hideWhiteSpace(this.target);
    }
    function handleOnComplete() {
      if (hasListItem) {
        hideLiTag(this.target);
      }
    }

    this.tweenToHandler(itemEl, duration, { x: `+=${txtContWidthMid}` }, exitStart);
    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        const itemHeight = words[i].offsetHeight;
        this.tweenToHandler(words[i], eachDur, { opacity: 0, y: `+=${itemHeight}`, onStart: handleOnStart, onComplete: handleOnComplete }, delaytime);
      } else {
        const itemHeight = words[i][0].offsetHeight;
        for (let j = 0; j < words[i].length; j++) {
          this.tweenToHandler(words[i][j], eachDur, { opacity: 0, y: `+=${itemHeight}`, onStart: handleOnStart, onComplete: handleOnComplete }, delaytime);
        }
      }
      delaytime += eachDur;
    }
  }

  stompWordsExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });


    this.tweenToHandler(itemEl, 0.000001, { willChange: "auto" }, exitStart - 0.000001); /** @Note the willChange applied in workspaceComp bulrs the text while scaling */
    const parentWidth = currentObj.get("width");
    const parentHorCenter = parentWidth / 2;
    let { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    words = words.reverse();
    let delaytime = exitStart + 0.000001;
    const dur = duration;
    const eachDur = dur / words.length;

    const whiteSpaces = Array.from(itemEl.querySelectorAll('[data-ws="true"]'));
    this.tweenSetHandler(exitStart, whiteSpaces, { opacity: 0 });

    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        const wordWidth = words[i].offsetWidth;
        const wordLeft = words[i].offsetLeft;
        const xTransForm = (parentHorCenter - wordLeft) - (wordWidth / 2);
        this.tweenToHandler(words[i], 0.000001, { opacity: 0, scale: 1, x: xTransForm, willChange: "auto", transformOrigin: `50% 50%` }, exitStart);
        this.tweenToHandler(words[i], eachDur - 0.000001, { opacity: 1, scale: 4, ease: Linear.easeOut }, delaytime);
        this.tweenToHandler(words[i], 0.000001, { opacity: 0 }, delaytime + eachDur);
      } else {
        let pseudoWidth = 0;
        const pseudoWordX = words[i][0].offsetLeft;
        for (let j = 0; j < words[i].length; j++) {
          pseudoWidth += words[i][j].offsetWidth;
        }
        const pseudoWordCenter = pseudoWordX + (pseudoWidth / 2);
        for (let j = 0; j < words[i].length; j++) {
          const xTransForm = (parentHorCenter - pseudoWordX) - (pseudoWidth / 2);
          const wordOrigin = pseudoWordCenter - (words[i][j].offsetLeft);
          this.tweenToHandler(words[i][j], 0.000001, { opacity: 0, scale: 1, x: xTransForm, willChange: "auto", transformOrigin: `${wordOrigin}px 50%` }, exitStart);
          this.tweenToHandler(words[i][j], eachDur - 0.000001, { opacity: 1, scale: 4, ease: Linear.easeOut }, delaytime);
          this.tweenToHandler(words[i], 0.000001, { opacity: 0 }, delaytime + eachDur);
        }
      }
      delaytime += eachDur;
    }
  }

  bounceLettersExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    let { chars } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    chars = chars.reverse();
    const eachDir = duration / chars.length;
    let startAt = exitStart;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
    }

    function hideLiTag(targetElm) {
      let prevElemSib = targetElm.previousElementSibling;
      while (prevElemSib !== null && (prevElemSib.dataset.ws === "true")) {
        prevElemSib.style.opacity = 0;
        prevElemSib = prevElemSib.previousElementSibling;
      }
      if (prevElemSib === null) {
        if (targetElm.parentElement.nodeName === "LI") {
          targetElm.parentElement.style.visibility = "hidden";
        }
      }
    }

    function hideWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 0;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function handleOnStart() {
      if (this.target.nextElementSibling === null) { /** @Note char based animation on the last element we pass the parentElement */
        hideWhiteSpace(this.target.parentElement);
      }
    }
    function onCompleteHandler() {
      if (hasListItem) {
        if (this.target instanceof HTMLElement && this.target.previousElementSibling === null) {
          hideLiTag(this.target.parentElement);
        }
      }
    }

    for (let i = 0; i < chars.length; i++) {
      const height = chars[i].offsetHeight;
      this.tweenToHandler(chars[i], eachDir, { y: `-=${height}`, opacity: 0, ease: Back.easeIn.config(2), onStart: handleOnStart, onComplete: onCompleteHandler }, startAt)
      startAt += eachDir;
    }

  }

  skateLettersExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { chars } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    const eachDur = duration / chars.length;
    const staggerDelay = eachDur /* / 2 */;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
    }

    function onCompleteHandler() {
      if (hasListItem) {
        if (this.target instanceof HTMLElement && this.target.nextElementSibling === null) {
          const { parentElement } = this.target;
          let parentNextSibLing = parentElement.nextElementSibling;
          while (parentNextSibLing !== null && (parentNextSibLing.nodeName === "BR" || parentNextSibLing.dataset.ws === "true")) {
            parentNextSibLing = parentNextSibLing.nextElementSibling;
          }
          if (parentNextSibLing === null) {
            this.target.closest("li").style.opacity = 0;
          }
        }
      }
    }
    function hideWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 0;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function handleOnStart() {
      if (this.target.nextElementSibling === null) { /** @Note char based animation on the last element we pass the parentElement */
        hideWhiteSpace(this.target.parentElement);
      }
    }

    this.tweenStaggerToHandler(chars, eachDur, { x: "-=40", opacity: 0, onStart: handleOnStart, onComplete: onCompleteHandler }, staggerDelay, exitStart);

  }


  skateWordsExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const { words } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    let delaytime = exitStart;
    const dur = duration;
    const eachDur = dur / words.length;

    const listItems = Array.from(itemEl.querySelectorAll('li')); let hasListItem = false;
    if (listItems.length > 0) {
      hasListItem = true;
    }

    function onCompleteHandler() {
      if (hasListItem) {
        let nextSibLingElm = this.target.nextElementSibling;
        let prevSiblingElm = this.target.previousElementSibling;
        while (prevSiblingElm !== null && (prevSiblingElm.dataset.ws === "true")) {
          if (prevSiblingElm.style.opacity === 1) {
            break;
          }
          prevSiblingElm.style.opacity = "0";
          prevSiblingElm = prevSiblingElm.previousElementSibling;
        }
        while (nextSibLingElm !== null && (nextSibLingElm.nodeName === "BR" || nextSibLingElm.dataset.ws === "true")) {
          nextSibLingElm = nextSibLingElm.nextElementSibling;
        }
        if (nextSibLingElm === null) {
          this.target.closest("li").style.opacity = 0;
        }
      }
    }

    function hideWhiteSpace(targetElm) {
      let nextSibling = targetElm.nextElementSibling;
      while (nextSibling instanceof HTMLElement && nextSibling.dataset.ws === "true") {
        nextSibling.style.opacity = 0;
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    function handleOnStart() {
      hideWhiteSpace(this.target);
    }

    for (let i = 0; i < words.length; i++) {
      if (words[i] instanceof HTMLElement) {
        this.tweenToHandler(words[i], eachDur, { x: "-=40", opacity: 0, onStart: handleOnStart, onComplete: onCompleteHandler }, delaytime + (eachDur / 2));
      } else {
        for (let j = 0; j < words[i].length; j++) {
          this.tweenToHandler(words[i][j], eachDur, { x: "-=40", opacity: 0, onStart: handleOnStart, onComplete: onCompleteHandler }, delaytime + (eachDur / 2));
        }
      }
      delaytime += eachDur;
    }
  }

  lineSlideExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    this.tweenSetHandler(exitStart, itemEl, { overflow: `hidden` })
    let { lines } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    lines = lines.reverse();
    const parentWidth = currentObj.get("width");
    let startAt = exitStart;
    const eachDelayDur = (duration * 0.2) / (lines.length - 1);
    let lineDuration = duration;
    let durationOffset = 0;
    function handleAllDone() {
      itemEl.style.overflow = "visible";
    }
    for (let i = 0; i < lines.length; i++) {
      const lineWords = Array.from(lines[i].querySelectorAll(".sp-wd"));
      const whiteSpaces = Array.from(lines[i].querySelectorAll('[data-ws="true"]'));
      this.tweenSetHandler(startAt, whiteSpaces, { opacity: 0 })
      this.tweenStaggerToHandler(lineWords, lineDuration, { x: `+${parentWidth}`, ease: Back.easeIn.config(1.7) }, 0, startAt, handleAllDone);
      startAt += eachDelayDur;
      durationOffset += eachDelayDur;
      lineDuration = duration - durationOffset;
    }
  }

  lineSlideZigZagExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const isChild = false;
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    this.tweenSetHandler(exitStart, itemEl, { overflow: `hidden` })

    let { lines } = getSplittedDom(itemEl, isChild, currentObj, this.props.zoomFactor);
    lines = lines.reverse();
    const parentWidth = currentObj.get("width") /* * this.props.zoomFactor */;
    const eachLineDur = (duration / lines.length);
    let startAt = exitStart;
    function handleAllDone() {
      itemEl.style.overflow = "visible";
    }
    for (let i = 0; i < lines.length; i++) {
      const lineWords = Array.from(lines[i].querySelectorAll(".sp-wd"));
      const whiteSpaces = Array.from(lines[i].querySelectorAll('[data-ws="true"]'));
      this.tweenSetHandler((startAt + (eachLineDur / 3)), whiteSpaces, { opacity: 0 })
      const setX = i % 2 === 0 ? `+${parentWidth}` : `-${parentWidth}`;
      this.tweenStaggerToHandler(lineWords, eachLineDur, { x: setX, ease: Elastic.easeIn.config(1, 0.7) }, 0, startAt, handleAllDone);
      startAt += eachLineDur /* / 2 */;
    }
  }

  panInExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    const dummyElement = itemEl.querySelectorAll(".splEff-wrapper")[1];
    const mainElement = itemEl.querySelectorAll(".splEff-wrapper")[0];
    const width = currentObj.get("width");
    this.tweenSetHandler(enterStart, itemEl, { overflow: "hidden" });
    this.tweenToHandler(mainElement, 0.0000001, { clearProps: "background" }, (exitStart));
    this.tweenToHandler(mainElement.firstChild, 0.0000001, { clearProps: "color" }, (exitStart));

    this.tweenToHandler(dummyElement, 0.0000001, { clipPath: 'none', webkitClipPath: 'none', overflow: "hidden", background: "rgb(198 212 188)", opacity: 1 }, exitStart);
    this.tweenToHandler(dummyElement.firstChild, 0.0000001, { color: "green" }, (exitStart));
    this.tweenToHandler(dummyElement, duration, { x: `-=${width}`, ease: Power0.easeNone }, exitStart);
    this.tweenToHandler(dummyElement.firstChild, duration, { x: `+=${width * 2}`, ease: Power0.easeNone }, exitStart);
    this.tweenToHandler(mainElement.firstChild, duration, { x: `+=${width}`, ease: Power0.easeNone }, exitStart);
  }

  emergeExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    const dummyElement = itemEl.querySelectorAll(".splEff-wrapper")[1];
    const mainElement = itemEl.querySelectorAll(".splEff-wrapper")[0];
    let clipPathOG = "";
    let clipPathDummy = "";
    const width = currentObj.get("width");
    const height = currentObj.get("height");
    const halfHeight = (0.5 * height);
    clipPathOG = `M 0 0  L ${width} 0 L ${width} ${halfHeight} L 0 ${halfHeight} L 0 0`;
    clipPathDummy = `M 0 ${halfHeight}  L ${width} ${halfHeight} L ${width} ${height} L 0 ${height} L 0 ${halfHeight}`;
    this.tweenToHandler(mainElement, 0.0000001, { clipPath: `path('${clipPathOG}')`, webkitClipPath: `path('${clipPathOG}')`, overflow: "hidden" }, exitStart)
    this.tweenToHandler(dummyElement, 0.0000001, { clipPath: `path('${clipPathDummy}')`, webkitClipPath: `path('${clipPathDummy}')`, overflow: "hidden", opacity: 1 }, exitStart)
    this.tweenToHandler(mainElement.firstChild, duration - 0.0000001, { y: `+=${halfHeight}` }, exitStart + 0.0000001)
    this.tweenToHandler(dummyElement.firstChild, duration - 0.0000001, { y: `-=${halfHeight}` }, exitStart + 0.0000001)
  }


  slideOpenExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const currentObj = this.currentObjectHandlder(item);
    const duration = currentObj.get("exitduration");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });

    const dummyElement = itemEl.querySelectorAll(".splEff-wrapper")[1];
    const mainElement = itemEl.querySelectorAll(".splEff-wrapper")[0];
    let clipPathOG = "";
    let clipPathDummy = "";
    const width = currentObj.get("width");
    const height = currentObj.get("height");
    const topCutSt = (0.5 * width) * this.props.zoomFactor;
    const bottomCutStart = (0.5 * width) * this.props.zoomFactor;
    // Added scaled with and height to avoid mask clipping issues in zoomed view in animo render. (VMK-8934)
    const scaledWidth = width * this.props.zoomFactor;
    const scaledHeight = height * this.props.zoomFactor;
    clipPathOG = `M 0 0  L ${topCutSt} 0 L ${bottomCutStart} ${scaledHeight} L 0 ${scaledHeight} L 0 0`;
    clipPathDummy = `M ${topCutSt} 0 L ${scaledWidth} 0 L ${scaledWidth} ${scaledHeight} L ${bottomCutStart} ${scaledHeight} L ${topCutSt} 0`;
    this.tweenToHandler(mainElement, 0.0000001, { clipPath: `path('${clipPathOG}')`, webkitClipPath: `path('${clipPathOG}')`, overflow: "hidden" }, exitStart)
    this.tweenToHandler(dummyElement, 0.0000001, { clipPath: `path('${clipPathDummy}')`, webkitClipPath: `path('${clipPathDummy}')`, overflow: "hidden", opacity: 1 }, exitStart)
    this.tweenToHandler(mainElement.firstChild, duration - 0.0000001, { x: `+=${topCutSt}` }, exitStart + 0.0000001)
    this.tweenToHandler(dummyElement.firstChild, duration + 0.0000001, { x: `-=${topCutSt}` }, exitStart + 0.0000001)
  }

  wipeEnterHandler = (itemEl, item) => {
    const effect = item.get("enterEffectName");
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd")
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    const rotation = item.get("angle");
    const scaleX = 1;
    const scaleY = 1;
    let type = ""
    if (itemEl.getElementsByClassName("text-container")[0]) {
      this.addMask(itemEl.id, "wipe", "", rotation, scaleX, scaleY, true, "Enter");
      type = "wipe"
    } else if (effect === "wipeBottomLeft" || effect === "wipeBottomRight" || effect === "wipeTopRight" || effect === "wipeTopLeft") {
      this.addMask(itemEl.id, "multiWipe", "", rotation, scaleX, scaleY, false, "Enter");
      type = "multiWipe"
    } else {
      this.addMask(itemEl.id, "wipe", "", rotation, scaleX, scaleY, false, "Enter");
      type = "wipe"
    }

    const mask_rect = `#mask_${itemEl.id}_rectEnter`;
    const maskName = `#mymask_${itemEl.id}${type}Enter`;
    const idVal = document.getElementById(itemEl.id);
    const bboxVal = idVal.getBoundingClientRect();
    this.tweenSetHandler(enterStart, mask_rect, { opacity: 0.001, transformOrigin: "50% 50%" });
    this.tweenSetHandler(enterStart - 0.1, itemEl, {
      transformOrigin: "50% 50%",
      clipPath: `url(${maskName})`,
      webkitClipPath: `url(${maskName})`,
      opacity: 0.001, // Prevent full transparency
      transform: "translateZ(0)" // GPU promotion
    }, true, () => {
      // Force repaint in Safari
      // eslint-disable-next-line no-void
      void itemEl.offsetHeight;
    });

    const yval = 0;
    const xval = 0;
    const totalCount = 2;

    switch (effect) {
      case "wipeUp": {
        this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
        this.tweenfromHandler(mask_rect, enterDuration, { attr: { y: parseFloat(yval) + ((bboxVal.height) * -scaleY) } }, enterStart);
        break;
      }
      case "wipeDown": {
        this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
        this.tweenfromHandler(mask_rect, enterDuration, { attr: { y: parseFloat(yval) + ((bboxVal.height) * scaleY) } }, enterStart);
        break;
      }
      case "wipeRight": {
        this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
        this.tweenfromHandler(mask_rect, enterDuration, { attr: { x: parseFloat(xval) + ((bboxVal.width) * scaleX) } }, enterStart);
        break;
      }
      case "wipeLeft": {
        this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
        this.tweenfromHandler(mask_rect, enterDuration, { attr: { x: parseFloat(xval) + ((bboxVal.width) * -scaleX) } }, enterStart)
        break;
      }
      case "wipeBottomLeft": {
        for (let count = 0; count < totalCount; count++) {
          this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
          if (count === 0) {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { y: parseFloat(yval) + ((bboxVal.height) * -scaleY) } }, enterStart);
          }
          else {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { x: parseFloat(xval) + ((bboxVal.width) * scaleX) } }, enterStart);
          }
        }
        break;
      }
      case "wipeBottomRight": {
        for (let count = 0; count < totalCount; count++) {
          this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
          if (count === 0) {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { y: parseFloat(yval) + ((bboxVal.height) * -scaleY) } }, enterStart);

          }
          else {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { x: parseFloat(xval) + ((bboxVal.width) * -scaleX) } }, enterStart)

          }
        }
        break;
      }
      case "wipeTopRight": {
        for (let count = 0; count < totalCount; count++) {
          this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
          if (count === 0) {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { y: parseFloat(yval) + ((bboxVal.height) * scaleY) } }, enterStart);

          }
          else {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { x: parseFloat(xval) + ((bboxVal.width) * -scaleX) } }, enterStart)

          }
        }
        break;
      }
      case "wipeTopLeft": {
        for (let count = 0; count < totalCount; count++) {
          this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
          if (count === 0) {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { y: parseFloat(yval) + ((bboxVal.height) * scaleY) } }, enterStart);
          }
          else {
            this.tweenfromHandler(mask_rect + count, enterDuration, { attr: { x: parseFloat(xval) + ((bboxVal.width) * scaleX) } }, enterStart);

          }
        }
        break;
      }
      default:
        break;
    }
    this.tweenSetHandler(enterEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none', opacity: 1 }, true);
  }

  squeeze = (itemEl, item) => {
    const effectName = item.get("enterEffectName");
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const enterDuration = item.get("enterEnd") - item.get("enterStart");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    if (effectName === "squeezev") {
      this.addMask(itemEl.id, "splitVer", undefined, undefined, undefined, undefined, undefined, "Enter");
    } else {
      this.addMask(itemEl.id, "splitHor", undefined, undefined, undefined, undefined, undefined, "Enter");
    }
    const mask_rect = `#mask_${itemEl.id}_rectEnter`;
    const totalCount = 2;
    this.tweenSetHandler(enterStart - 0.01, itemEl, { clipPath: `url(#mymask_${itemEl.id})`, webkitClipPath: `url(#mymask_${itemEl.id}split)` }, true);

    for (let count = 0; count < totalCount; count++) {
      if (effectName === "squeezev") {
        if (count === 0) {
          this.tweenFromToHandler(mask_rect + count, enterDuration, { transformOrigin: "0%", scaleX: 0 }, { transformOrigin: "0%", scaleX: 1 }, enterStart);
        }
        else {
          this.tweenFromToHandler(mask_rect + count, enterDuration, { transformOrigin: "100%", scaleX: 0 }, { transformOrigin: "100%", scaleX: 1 }, enterStart);
        }
      } else if (effectName === "squeezeh") {
        if (count === 0) {
          this.tweenFromToHandler(mask_rect + count, enterDuration, { scaleY: 0 }, { scaleY: 1 }, enterStart);
        }
        else {
          this.tweenFromToHandler(mask_rect + count, enterDuration, { transformOrigin: "bottom", scaleY: 0 }, { transformOrigin: "bottom", scaleY: 1 }, enterStart);
        }
      }
    }
    this.tweenSetHandler(enterEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);

  }

  blindsEnterHandler = (itemEl, item) => {
    const enterStartValue = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const effectName = item.get("enterEffectName");
    const duration = enterEnd - enterStartValue;
    const totalCount = 10;
    this.removeMask(`${itemEl.id}Enter`)
    let type = "";
    if (effectName === "horizontalLeftSlice" || effectName === "horizontalRightSlice") {
      type = "multiWidth"
    } else if (effectName === "verticalUpSlice" || effectName === "verticalDownSlice") {
      type = "multiHeight"
    }
    this.addMask(itemEl.id, type, undefined, undefined, undefined, undefined, undefined, "Enter");
    const mask_rect = `#mask_${itemEl.id}_rectEnter`;
    const maskName = `#mymask_${itemEl.id}${type}Enter`;
    this.tweenSetHandler(enterStartValue, itemEl, { opacity: item.get("opacity") });
    this.tweenSetHandler(enterStartValue, itemEl, { transformOrigin: "50% 50%", clipPath: `url(${maskName})`, webkitClipPath: `url(${maskName})` }, true);
    const equalTime = duration / totalCount;

    for (let count = 0; count < totalCount; count++) {
      switch (effectName) {
        case "horizontalLeftSlice": {
          const newCount = (totalCount - 1) - count;
          const startTimeVal = equalTime * count;
          const enterStart = enterStartValue + startTimeVal
          this.tweenFromToHandler(mask_rect + newCount, equalTime + 0.4, { transformOrigin: "0%", scaleX: 0 }, { transformOrigin: "0%", scaleX: 1 }, enterStart - 0.03);
          break;
        }
        case "horizontalRightSlice": {
          const startTimeVal = equalTime * count;
          const enterStart = enterStartValue + startTimeVal
          this.tweenFromToHandler(mask_rect + count, equalTime + 0.4, { transformOrigin: "100%", scaleX: 0 }, { transformOrigin: "100%", scaleX: 1 }, enterStart - 0.03);
          break;
        }
        case "verticalUpSlice": {
          const newCount = (totalCount - 1) - count;
          const startTimeVal = equalTime * count;
          const enterStart = enterStartValue + startTimeVal
          this.tweenFromToHandler(mask_rect + newCount, equalTime + 0.4, { scaleY: 0 }, { scaleY: 1 }, enterStart - 0.03);
          break;
        }
        case "verticalDownSlice": {
          const startTimeVal = equalTime * count;
          const enterStart = enterStartValue + startTimeVal
          this.tweenFromToHandler(mask_rect + count, equalTime + 0.4, { transformOrigin: "bottom", scaleY: 0 }, { transformOrigin: "bottom", scaleY: 1 }, enterStart - 0.03);
          break;
        }
        default:
          break;
      }
    }
    this.tweenSetHandler(enterEnd, itemEl, { clipPath: "none", webkitClipPath: "none" }, true);
  }

  blindsExitHandler = (itemEl, item) => {
    const exitStartValue = item.get("exitStart");
    const exitEnd = item.get("exitEnd");
    const exitStart = item.get("exitStart");
    const duration = exitEnd - exitStartValue;
    const effectType = item.get("exitEffectName");
    let type = "";
    if ((effectType === "horizontalLeftSlice") || (effectType === "horizontalRightSlice")) {
      type = "multiWidth"
    } else if ((effectType === "verticalUpSlice") || (effectType === "verticalDownSlice")) {
      type = "multiHeight"
    }
    this.addMask(itemEl.id, type, undefined, undefined, undefined, undefined, undefined, "Exit");

    const mask_rect = `#mask_${itemEl.id}_rectExit`;
    const mask_name = `#mymask_${itemEl.id}${type}Exit`;
    this.tweenSetHandler(exitStart, mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
    this.tweenSetHandler(exitStart, itemEl, { opacity: 1, transformOrigin: "50% 50%" });
    this.tweenSetHandler(exitStart, itemEl, { opacity: 1, transformOrigin: "50% 50%", clipPath: `url(${mask_name})`, webkitClipPath: `url(${mask_name})` }, true);
    const totalCount = 10;
    const equalTime = duration / totalCount;
    for (let count = 0; count < totalCount; count++) {
      switch (effectType) {
        case "horizontalLeftSlice": {
          const newCount = (totalCount - 1) - count;
          const startTimeVal = equalTime * count;
          const exitStart = exitStartValue + startTimeVal
          this.tweenToHandler(mask_rect + newCount, equalTime + 0.4, { scaleX: 0, transformOrigin: "100%" }, exitStart - 0.4);
          break;
        }
        case "horizontalRightSlice": {
          const startTimeVal = equalTime * count;
          const exitStart = exitStartValue + startTimeVal
          this.tweenToHandler(mask_rect + count, equalTime + 0.4, { scaleX: 0, transformOrigin: "0%" }, exitStart - 0.4);
          break;
        }

        case "verticalUpSlice": {
          const newCount = (totalCount - 1) - count;
          const startTimeVal = equalTime * count;
          const exitStart = exitStartValue + startTimeVal
          this.tweenToHandler(mask_rect + newCount, equalTime + 0.4, { transformOrigin: "bottom", scaleY: 0 }, exitStart - 0.4);
          break;
        }
        case "verticalDownSlice": {
          const startTimeVal = equalTime * count;
          const exitStart = exitStartValue + startTimeVal
          this.tweenToHandler(mask_rect + count, equalTime + 0.4, { transformOrigin: "top", scaleY: 0 }, exitStart - 0.4);
          break;
        }
        default:
          break;
      }
    }
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
    this.tweenSetHandler(exitEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);
  }

  exitEffects = (itemEl, item) => {
    const effect = item.get("exitEffectName");
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart

    const widthVal = item.get("width");
    const heightVal = item.get("height")
    const projectHeight = this.props.projectData.get("height");
    const projectWidth = this.props.projectData.get("width");

    const groupXoffset = 0;
    const groupYoffset = 0;

    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    switch (effect) {
      case "exitToLeft": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: (widthVal * (-1)) - groupXoffset }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      case "exitToLeftBottom": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: (widthVal * (-1)) - groupXoffset, y: projectHeight }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      case "exitToTop": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { y: (heightVal * (-1)) - groupYoffset }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      case "exitToRight": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: projectWidth * this.props.zoomFactor }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      case "exitToBottom": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { y: (projectHeight * this.props.zoomFactor) }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      case "exitToRightTop": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: projectWidth * this.props.zoomFactor, y: (heightVal * (-1)) - groupYoffset }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      case "exitToRightBottom": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: projectWidth * this.props.zoomFactor, y: projectHeight * this.props.zoomFactor }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      case "exitToLeftTop": {
        const onStartTween = (itemId) => {
          this.removeMask(itemId);
          this.tweenToHandler(itemEl, duration, { x: (widthVal * (-1)) - groupXoffset, y: (heightVal * (-1)) - groupYoffset }, exitStart);
        }
        this.tweenfromHandler(itemEl.id, duration, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id], opacity: 1 }, exitStart);
        break;
      }
      default:
        break;
    }
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
  }

  exitHideEffects = (itemEl, item) => {
    const xval = item.get("x");
    const yval = item.get("y");
    const rotation = item.get("angle");
    const scaleX = 1;
    const scaleY = 1;
    const effect = item.get("exitEffectName");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = (exitEnd - exitStart)

    const groupXoffset = 0;
    const groupYoffset = 0;
    this.addMask(itemEl.id, "wipe", "", rotation, scaleX, scaleY, undefined, "Exit");
    const mask_rect = `#mask_${itemEl.id}_rectExit`;
    const mask_name = `#mymask_${itemEl.id}wipeExit`;
    const idVal = document.getElementById(itemEl.id);
    const bboxVal = idVal.getBoundingClientRect();
    this.tweenSetHandler(exitStart, itemEl, { /* x: xval - groupXoffset, y: yval - groupYoffset, */ clipPath: `url(${mask_name})`, webkitClipPath: `url(${mask_name})` }, true);
    this.tweenSetHandler(exitStart, itemEl.id, { x: xval * this.props.zoomFactor - groupXoffset, y: yval * this.props.zoomFactor - groupYoffset });
    const yvalue = document.getElementById(`mask_${itemEl.id}_rectExit`).getAttribute("y")
    const xvalue = document.getElementById(`mask_${itemEl.id}_rectExit`).getAttribute("x")

    switch (effect) {
      case "slideDown": {
        this.tweenToHandler(mask_rect, duration, { attr: { y: (parseFloat(yvalue) + (bboxVal.height * (-scaleY))) } }, exitStart);
        this.tweenToHandler(itemEl, duration, { y: (yval + bboxVal.height) - groupYoffset }, exitStart);
        break;
      }
      case "slideRight": {
        this.tweenToHandler(mask_rect, duration, { attr: { x: parseFloat(xvalue) + (bboxVal.width) * -scaleX } }, exitStart);
        this.tweenToHandler(itemEl, duration, { x: bboxVal.width + xval - groupXoffset }, exitStart);
        break;
      }
      case "slideUp": {
        this.tweenToHandler(mask_rect, duration, { attr: { y: parseFloat(yvalue) + (bboxVal.height * (scaleY)) } }, exitStart);
        this.tweenToHandler(itemEl, duration, { y: (yval - bboxVal.height - groupYoffset) }, exitStart);
        break;
      }
      case "slideLeft": {
        this.tweenToHandler(mask_rect, duration, { attr: { x: parseFloat(xvalue) + (bboxVal.width * scaleX) } }, exitStart);
        this.tweenToHandler(itemEl, duration, { x: (xval - bboxVal.width - groupXoffset) }, exitStart);
        break;
      }
      default:
        break;
    }
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
    this.tweenSetHandler(exitEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);
  }

  wipeExitHandler = (itemEl, item) => {
    const rotation = item.get("angle");
    const scaleX = 1;
    const scaleY = 1;

    const effect = item.get("exitEffectName");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd");
    const duration = exitEnd - exitStart
    this.addMask(itemEl.id, "wipe", "", rotation, scaleX, scaleY, "", "Exit");
    const mask_rect = `#mask_${itemEl.id}_rectExit`;
    const idVal = document.getElementById(itemEl.id);
    const bboxVal = idVal.getBoundingClientRect();
    const offset = 2;
    const yval = document.getElementById(`mask_${itemEl.id}_rectExit`).getAttribute("y")
    const xval = document.getElementById(`mask_${itemEl.id}_rectExit`).getAttribute("x")
    this.tweenSetHandler(exitStart, itemEl, { opacity: 1, transformOrigin: "50% 50%", clipPath: `url(#mymask_${itemEl.id}wipeExit)`, webkitClipPath: `url(#mymask_${itemEl.id}wipeExit)` }, true);

    switch (effect) {
      case "wipeUp": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY) } }, exitStart - 0.5);
        break;
      }
      case "wipeDown": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } }, exitStart - 0.5);
        break;
      }
      case "wipeRight": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } }, exitStart - 0.5);
        break;
      }
      case "wipeLeft": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } }, exitStart - 0.5);
        break;
      }
      case "wipeBottomRight": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY) } }, exitStart - 0.5);
        this.t1.to(mask_rect, duration + 0.5, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } }, exitStart - 0.5);
        break;
      }
      case "wipeBottomLeft": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY) } }, exitStart - 0.5);
        this.t1.to(mask_rect, duration + 0.5, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } }, exitStart - 0.5);
        break;
      }
      case "wipeTopLeft": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } }, exitStart - 0.5);
        this.t1.to(mask_rect, duration + 0.5, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } }, exitStart - 0.5);
        break;
      }
      case "wipeTopRight": {
        this.t1.to(mask_rect, duration + 0.5, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } }, exitStart - 0.5);
        this.t1.to(mask_rect, duration + 0.5, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } }, exitStart - 0.5);
        break;
      }
      default:
        break;
    }
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
    this.tweenSetHandler(exitEnd, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);
  }

  applyRotateZoomOutEffect = (itemEl, item) => {

    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    const effect = item.get("exitEffectName");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    function onStartTween(blockId, type) {
      this.removeMask(blockId);
      if (type === "rotateZoomOutCcw")
        this.tweenToHandler(itemEl, duration, { rotation: "-=180", scale: 0, transformOrigin: "50% 50%" }, exitStart);
      else if (type === "rotateZoomOutCw")
        this.tweenToHandler(itemEl, duration, { rotation: "+=180", transformOrigin: "50% 50%" }, exitStart);
      this.tweenToHandler(itemEl, duration, { scale: 0, transformOrigin: "50% 50%" }, exitStart);
    }
    this.tweenfromHandler(itemEl.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id, effect], opacity: 1 }, exitStart);

  }

  rotateZoomoutPopup = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    const effect = item.get("exitEffectName");
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    function onStartTween(blockId, type) {
      this.removeMask(blockId);
      this.tweenFromToHandler(itemEl, duration - 0.0000001, { scale: 1.2 }, { scale: 0, transformOrigin: "50% 50%", ease: Back.easeIn }, exitStart + 0.0000001);
      if (type === "rotateZoomOutPopupCcw")
        this.tweenToHandler(itemEl, duration - duration / 2, { rotation: "-=360", transformOrigin: "50% 50%" }, exitStart);
      else if (type === "rotateZoomOutPopupCw")
        this.tweenToHandler(itemEl, duration - duration / 2, { rotation: "+=360", transformOrigin: "50% 50%" }, exitStart);
    }
    this.tweenfromHandler(itemEl.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [itemEl.id, effect], opacity: 1 }, exitStart);
  }

  brightSquareExitHandler = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitStart = item.get("exitStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - exitStart
    const suffix = "Exit";
    this.addMask(itemEl.id, "square", "", "", 1, 1, "exit", "Exit");
    const mask_rect = `#mask_${itemEl.id}_rect${suffix}exit`;
    const maskName = `#mymask_${itemEl.id}exitsquare${suffix}`;

    this.tweenSetHandler(enterStart, itemEl, { opacity: 1 });
    this.tweenSetHandler(enterStart, itemEl, { clipPath: `url(${maskName})`, webkitClipPath: `url(${maskName})` }, true);
    const totalCount = 6;
    for (let count = 0; count < totalCount; count++) {
      for (let cnt = 0; cnt < totalCount; cnt++) {
        this.tweenToHandler(mask_rect + count + cnt, duration + 0.5, { transformOrigin: "50% 50%", scale: 0 }, exitStart)
      }
    }
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
    this.tweenSetHandler(exitEnd + 0.1, itemEl, { clipPath: 'none', webkitClipPath: 'none' }, true);
  }

  applyNoEnterEffect = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const isRestrict = item.get("isRestrict");
    const end = item.get("enterStart") + item.get("videoEnd");
    if (enterStart > 0) {
      this.tweenSetHandler(0, itemEl, { opacity: 0 });
    }
    function onStartTween() {
      if (isRestrict) {
        // Exit fullscreen if in fullscreen mode
        if (document.fullscreenElement && this.props.isAnimoPlayer) {
          document.exitFullscreen();
          this.props.setAnimoFullScreen({ isFullScreen: false });
        }
        if (this.props.isAnimoPlayer) {
          this.playEnded();
          this.props.setPlayHeadTime({ playhead: 0 });
        } else {
          this.props.setPlayAll(false);
          this.t1.pause(end - 0.01, false);
        }
        this.props.showUpgrades({ upgradesource: 'Avatar-timeline-restriction' });
      }
    }
    if (isRestrict) {
      this.tweenfromHandler(itemEl.id, 0.1, { onStart: onStartTween.bind(this), opacity: 1 }, end - 0.01);
    } else {
      this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    }
  }


  transitionNoEnterEffect = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    if (enterStart > 0) {
      this.tweenSetHandler(0, itemEl, { opacity: 0 });
    }
    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
  }

  transitionNoExitEffect = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const duration = transitionTime;
    if (enterStart > 0) {
      this.tweenSetHandler(0, itemEl, { opacity: 0 });
    }
    const time = Math.max(0, enterStart - duration);
    this.tweenSetHandler(time, itemEl, { opacity: 1 });
  }

  applyNoExitEffect = (itemEl, item) => {
    const exitEnd = item.get("exitEnd");
    this.tweenSetHandler(exitEnd, itemEl, { opacity: 0 });
  }

  enterSplitEffects = (itemEl, item) => {
    const effect = item.get("enterEffectName");
    const enterStart = item.get("enterStart");
    const enterEnd = item.get("enterEnd");
    const duration = enterEnd - enterStart;

    this.removeMask(itemEl.id, "reveal");
    this.addMask(itemEl.id, "reveal");
    const maskRect = `#mask_${itemEl.id}_rect`;

    this.tweenSetHandler(enterStart, maskRect, { attr: { x: 0, y: 0 }, opacity: 1, transformOrigin: "50% 50%" });
    this.tweenSetHandler(enterStart, itemEl, { opacity: 1, transformOrigin: "50% 50%" });

    this.tweenSetHandler(enterStart, maskRect, { attr: { x: 0, y: 0 }, opacity: 1, transformOrigin: "50% 50%" });
    if (effect === "verticalSplit") {
      this.tweenFromToHandler(maskRect, duration, { scaleX: 0, transformOrigin: "50% 50%" }, { scaleX: 1, transformOrigin: "50% 50%", attr: { y: 0 } }, enterStart);
    } else if (effect === "horizontalSplit") {
      this.tweenFromToHandler(maskRect, duration, { scaleY: 0, transformOrigin: "50% 50%" }, { scaleY: 1, transformOrigin: "50% 50%", attr: { y: 0 } }, enterStart);
    }
  }

  textReveal = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - enterStart;
    const mySplitText = new SplitText(itemEl, { type: "words", reduceWhiteSpace: false });
    const { words } = mySplitText;
    function allDone() {
      mySplitText.revert();
    }
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1 }, enterStart);
    this.tweenSetHandler(enterStart, words, { visibility: "hidden" });
    this.tweenStaggerToHandler(words.slice(), (duration / words.length), { visibility: "visible", ease: Linear.easeNone, willChange: "transform, opacity", immediateRender: false }, (duration / words.length), enterStart, allDone);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textHighlight = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - enterStart;
    this.removeMask(itemEl.id);
    const highlightNode = document.createElement("div");
    highlightNode.id = "highlight-node";
    highlightNode.style.backgroundColor = this.props.projectData.getIn(["subtitle", "animData", "colorProp"]);
    highlightNode.style.display = "none";
    highlightNode.style.position = "absolute";
    highlightNode.style.borderRadius = "3px";
    const mySplitText = new SplitText(itemEl, { type: "words", wordsClass: "splitedWords++", reduceWhiteSpace: false });
    function placeNode() {
      const width = this.target.offsetWidth;
      const height = this.target.offsetHeight;
      const top = this.target.offsetTop;
      const left = this.target.offsetLeft;
      highlightNode.style.width = `${width + 4}px`;
      highlightNode.style.height = `${height + 4}px`;
      highlightNode.style.top = `${top - 3.9}px`;
      highlightNode.style.left = `${left - 2}px`;
      highlightNode.style.display = `block`;
      highlightNode.style.zIndex = "-1";
      itemEl.appendChild(highlightNode);
    }
    function allDone() {
      mySplitText.revert();
    }
    const { words } = mySplitText;
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1 }, enterStart);
    this.tweenStaggerToHandler(words.slice(), (duration / words.length), { ease: Linear.easeNone, willChange: "transform, opacity", immediateRender: false, onStart: placeNode }, (duration / words.length), enterStart, allDone);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textFlip = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - enterStart;
    let animDuration = 1;
    if (animDuration >= duration) {
      if (duration <= 0.5) {
        animDuration = 0.2
      } else if (duration > 0.5 && duration <= 1) {
        animDuration = 0.5
      }
    }
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1 }, enterStart);
    this.tweenSetHandler(0, itemEl, { rotationX: 50, opacity: 0, transformPerspective: 1000 });
    this.tweenToHandler(itemEl, animDuration, { opacity: 1, perspective: 0, rotationX: 0, ease: Back.easeOut.config(0.5) }, enterStart)
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textAlphaFadeEffect = (itemEl, item) => {
    const effect = this.props.projectData.getIn(["subtitle", "animData", "animation"]);
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - enterStart;
    function tweenStart() {
      this.target.style.opacity = 1;
    }
    function tweenEnd() {
      if (effect === "textAlphaFadeOut") {
        this.target.style.opacity = 0.3;
      }
    }
    const mySplitText = new SplitText(itemEl, { type: "words", reduceWhiteSpace: false });
    const { words } = mySplitText;
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1 }, enterStart);
    this.tweenSetHandler(enterStart, words, { opacity: 0.3 });
    this.tweenStaggerToHandler(words.slice(), (duration / words.length), {
      ease: Linear.easeNone, willChange: "transform, opacity", immediateRender: false, onStart: tweenStart, onComplete: tweenEnd
    }, (duration / words.length), enterStart, () => {
      mySplitText.revert();
    });
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textScaleIn = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const fontSize = 20;
    const mySplitText = new SplitText(itemEl, { type: "words", reduceWhiteSpace: false });
    const { words } = mySplitText;
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1 }, enterStart);
    this.tweenSetHandler(enterStart, words, { opacity: 0, fontSize: 0 });
    this.tweenStaggerToHandler(words, 0.5, { opacity: 1, fontSize, ease: Power1.easeOut, willChange: "transform, opacity", immediateRender: false, stagger: { each: 0, from: "left" } }, 0, enterStart);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textRevealWordbyWord = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const height = item.get("height")
    const duration = exitEnd - enterStart;
    const y = item.get("y");
    const mySplitText = new SplitText(itemEl, { type: "words", reduceWhiteSpace: false });
    const { words } = mySplitText;
    itemEl.style.display = "flex";
    function tweenStart() {
      this.target.style.display = "inline-block";
    }
    function tweenEnd() {
      this.target.style.display = "none";
    }
    function allDone() {
      mySplitText.revert();
    }
    const elemY = y * this.props.zoomFactor;
    const elemHeight = height * this.props.zoomFactor;
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", x: 0, y: elemY, width: "100%", height: `${elemHeight}px`, maxWidth: "100%" }, enterStart);
    this.tweenSetHandler(enterStart, words, { visibility: "hidden", display: "none" });
    this.tweenStaggerToHandler(words.slice(), (duration / words.length), { visibility: "visible", ease: Linear.easeNone, willChange: "transform, opacity", immediateRender: false, onStart: tweenStart, onComplete: tweenEnd }, (duration / words.length), enterStart, allDone);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textFloat = (itemEl, item) => {
    const effect = this.props.projectData.getIn(["subtitle", "animData", "animation"]);
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - enterStart;

    const mySplitText = new SplitText(itemEl, { type: "words", reduceWhiteSpace: false });
    const { words } = mySplitText;
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1 }, enterStart);
    let y = -20;
    if (effect === "textFloatUp") {
      y = 20;
    }
    function allDone() {
      mySplitText.revert();
    }
    this.tweenSetHandler(enterStart, words, { visibility: "hidden", y });
    this.tweenStaggerToHandler(words.slice(), (duration / words.length), { visibility: "visible", y: 0, ease: Expo.easeOut, willChange: "transform, opacity", immediateRender: false }, (duration / words.length), enterStart, allDone);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textDropIn = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - enterStart;
    this.tweenSetHandler(enterStart, itemEl, { opacity: item.get("opacity") });
    const childNode = itemEl.childNodes[0]

    const mySplitText = new SplitText(childNode, { type: "words,lines", reduceWhiteSpace: false });

    const { words } = mySplitText;
    const { lines } = mySplitText;
    this.tweenToHandler(childNode, 0.0000001, { opacity: 1 }, enterStart);
    let x = 0; let y = 0;
    let wordCount = 0;
    for (let i = 0; i < lines.length; i++) {
      const splitWord = new SplitText(lines[i], { type: "words", reduceWhiteSpace: false });
      const splittedWords = splitWord.words;
      const totalLength = splittedWords.length;
      const divider = totalLength >= 3 ? 3 : 2;
      const midStartIndex = Math.round((totalLength / divider));
      const midEndIndex = Math.round((splittedWords.length / 2));
      for (let i = 0; i < splittedWords.length; i++) {
        const elem = words[wordCount];
        x = 0;
        y = -10;
        if (splittedWords.length <= 3) {
          x = -10
        } else if (i === 0) {
          x = -50
        } else if (i <= midStartIndex) {
          x = -50;
        } else if (i > midStartIndex && i <= midEndIndex) {
          x = 10;
        } else {
          x = 50;
        }
        this.tweenSetHandler(enterStart, elem, { opacity: 0, x, y, scaleX: 1, scaleY: 1.3 });
        wordCount++;
      }
    }
    function allDone() {
      mySplitText.revert();
    }
    this.tweenStaggerToHandler(words.slice(), (duration / words.length), { opacity: 1, x: 0, y: 0, scaleX: 1, scaleY: 1, ease: Expo.easeOut, willChange: "transform, opacity", immediateRender: false }, (duration / words.length), enterStart, allDone);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textColorHighlight = (itemEl, item) => {
    const enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd")
    const duration = exitEnd - enterStart;
    const highlightColor = this.props.projectData.getIn(["subtitle", "animData", "colorProp"]);
    function tweenStart() {
      this.target.style.color = highlightColor;
    }
    function tweenEnd() {
      this.target.style.color = "";
    }
    const mySplitText = new SplitText(itemEl, { type: "words", reduceWhiteSpace: false });
    const { words } = mySplitText;
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 1 }, enterStart);
    this.tweenStaggerToHandler(words.slice(), (duration / words.length), { ease: Linear.easeNone, willChange: "transform, opacity", immediateRender: false, onStart: tweenStart, onComplete: tweenEnd }, (duration / words.length), enterStart);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  }

  textPopupWordbyWord = (itemEl, item) => {
    let enterStart = item.get("enterStart");
    const exitEnd = item.get("exitEnd");
    let duration = exitEnd - enterStart;
    const parentHeight = item.get("height");

    // Prevent zero-duration issue
    if (enterStart === 0) {
      enterStart += 0.000001;
      duration -= 0.000001;
    }

    // Split words
    const mySplitText = new SplitText(itemEl, { type: "words", reduceWhiteSpace: false });
    const { words } = mySplitText;
    itemEl.children[0].style.display = "flex";

    // Ensure container setup
    this.tweenToHandler(itemEl, 0.0000001, {
      opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", x: 0,
      y: item.get("y") * this.props.zoomFactor,
      width: "100%",
      height: `${parentHeight * this.props.zoomFactor}px`,
      maxWidth: "100%"
    },
      enterStart
    );

    // Animation logic
    const wordsLen = words.length;
    let wordStartTime = enterStart;
    const eachDur = duration / wordsLen;

    // loop
    for (let i = 0; i < wordsLen; i++) {
      // stack every word at the center
      this.tweenSetHandler(
        0.1,
        words[i],
        {
          position: "absolute",
          left: "50%",
          top: "50%",
          x: "-50%",      // center via translate
          y: "-50%",
          visibility: "hidden",
          opacity: 0,
          scale: 0.7,
          transformOrigin: "50% 50%",
          whiteSpace: "nowrap",
          willChange: "transform, opacity"
        },
        true
      );

      // scale in at center
      this.tweenToHandler(
        words[i],
        eachDur * 0.5,
        { scale: 1, visibility: "visible", opacity: 1, ease: Linear.easeOut },
        wordStartTime
      );

      // hide again but KEEP center position (do NOT reset x/y)
      this.tweenSetHandler(
        wordStartTime + eachDur,
        words[i],
        { visibility: "hidden", opacity: 0 },
        true
      );

      wordStartTime += eachDur;
    }

    this.tweenSetHandler(enterStart + duration, words, { visibility: "visible" }, true);
    this.tweenToHandler(itemEl, 0.0000001, { opacity: 0 }, exitEnd);
  };

  /* Put ADD_TWEEN wrappers after this comment */

  tweenToHandler = (playerDOM, startTime, toVal, time) => {
    this.props.addTween({ playerDOM, startTime, toVal, time }, "to");
  }

  tweenfromHandler = (playerDOM, startTime, fromVal, time) => {
    this.props.addTween(
      {
        playerDOM,
        startTime,
        fromVal,
        time,
      },
      "from"
    );
  }

  tweenFromToHandler = (playerDOM, startTime, fromVal, toVal, time) => {
    this.props.addTween(
      {
        playerDOM,
        startTime,
        fromVal,
        toVal,
        time,
      },
      "fromTo"
    );
  }

  tweenStaggerFromToHandler = (
    playerDOM,
    startTime,
    fromVal,
    toVal,
    staggerTime,
    time
  ) => {
    this.props.addTween(
      {
        playerDOM,
        startTime,
        fromVal,
        toVal,
        staggerTime,
        time,
      },
      "staggerFromTo"
    );
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  tweenStaggerToHandler = (playerDOM, startTime, toVal, staggerTime, time) => {
    this.props.addTween(
      {
        playerDOM,
        startTime,
        toVal,
        staggerTime,
        time,
      },
      "staggerTo"
    );
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  tweenStaggerFromHandler = (
    playerDOM,
    startTime,
    fromVal,
    staggerTime,
    time,
    onComplete
  ) => {
    this.props.addTween(
      {
        playerDOM,
        startTime,
        fromVal,
        staggerTime,
        time,
        onComplete,
      },
      "staggerFrom"
    );
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  tweenSetPropHandler = (elem, vals) => {
    this.props.addTween(
      { playerDOM: elem, setType: "styles", setVal: vals },
      "set"
    );
  }

  tweenSetHandler = (time, playerDOM, setVal) => {
    this.props.addTween({ time, playerDOM, setVal }, "set");
  }

  tweenAddCallbackHandler = (valArr) => {
    this.props.addTween(valArr, "addCallback");
    // this.tweenCount ++;
  }

  render() {
    const workspaceBG = this.props.projectData.get("workspaceBG");
    const workspaceItems = this.props.projectData.get("workspaceItems");
    const workspaceChildren = this.props.projectData.get("workspaceChildren");
    const allVideos = this.filterVideos.executor(
      [workspaceBG, workspaceItems, workspaceChildren],
      workspaceBG,
      workspaceItems,
      workspaceChildren
    );

    return (
      <PlayerAudio
        key="player-audio"
        audios={this.props.projectData.get("audios")}
        videos={allVideos}
      >
        {this.props.children}
      </PlayerAudio>
    );
  }
}

PlayerComponent.propTypes = {
  videoBufferStatus: PropTypes.object,
  projectData: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  appReframeData: PropTypes.object,
  addTween: PropTypes.func,
  isLoaded: PropTypes.bool,
  t1: PropTypes.object,
  runningState: PropTypes.object,
  prefetchCount: PropTypes.number,
  prefetchCompleteCount: PropTypes.number,
  startPlay: PropTypes.func,
  setPlayAll: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  zoomFactor: PropTypes.number,
  isAnimLoaded: PropTypes.bool,
  isAnimoPlayer: PropTypes.bool,
  isShortsPlayer: PropTypes.bool,
  isPausePlayer: PropTypes.bool,
  pausePlayer: PropTypes.func,
  showUpgrades: PropTypes.func,
  setPlayHeadTime: PropTypes.func,
  setAnimoFullScreen: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  videoBufferStatus: state.app.get("videoBufferStatus"),
  projectData: state.projectDetails,
  appReframeData: state.app.get("reframeData"),
  t1: state.app.get("t1"),
  isLoaded: state.app.get("isLoaded"),
  runningState: state.app.get("runningState"),
  prefetchCount: state.app.get("prefetchCount"),
  prefetchCompleteCount: state.app.get("prefetchCompleteCount"),
  prefetchToken: state.app.get("prefetchToken"),
  zoomFactor: state.app.get("zoomFactor"),
  isAnimLoaded: state.app.get("isAnimLoaded"),
  isAnimoPlayer: state.app.get("isAnimoPlayer"),
  isShortsPlayer: state.app.get("isShortsPlayer"),
  isPausePlayer: state.app.get("isPausePlayer"),
  userDetails: state.userDetails,
  isReframeMode: state.app.get("isReframeMode"),
  selectedItems: state.app.get("selectedItems"),
  selectedSubtitles: state.app.get("selectedSubtitles"),
});

const mapDispatchToProps = (dispatch) => ({
  addTween: (data, tweenType) => {
    dispatch(addTween(data, tweenType));
  },
  setPlayAll: (isPlayAll, isFullPreview, isClipEnd) => dispatch(setPlayAll(isPlayAll, isFullPreview, isClipEnd)),
  startPlay: (data) => dispatch(startPlay(data)),
  pausePlayer: (data) => dispatch(playPausePlayer(data)),
  showUpgrades: (data) => dispatch(showUpgrade(data)),
  setPlayHeadTime: (data) => dispatch(setPlayHeadTime(data)),
  setAnimoFullScreen: (data) => dispatch(setAnimoFullScreen(data)),
});

const Player = connect(mapStateToProps, mapDispatchToProps)(PlayerComponent);

export default Player;